import React, { useEffect, useState, useRef } from 'react';
import ReadMoreArea from '@foxeian/react-read-more';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { Editor } from '@tinymce/tinymce-react';
import axios from 'axios';
import {
	Row,
	Col,
	Button,
	Input,
	Space,
	Divider,
	notification,
	Affix,
	Select,
	Tooltip,
	Tag,
	List,
	Checkbox,
	Radio,
	Modal,
	Avatar,
	Form,
	Upload,
	Dropdown,
	Card,
	Grid,
	Spin,
} from 'antd';
import {
	ArrowLeftOutlined,
	WarningOutlined,
	PlusOutlined,
	EditOutlined,
	FileTextOutlined,
	FileImageOutlined,
	UserOutlined,
	AntDesignOutlined,
	DeleteOutlined,
	CloseOutlined,
	FilePdfOutlined,
	InboxOutlined,
	EyeOutlined,
	CaretRightOutlined,
	DownOutlined,
	EllipsisOutlined,
	AudioOutlined,
	PlayCircleOutlined,
	CheckOutlined,
	PauseOutlined,
	RedoOutlined,
	PlusCircleFilled,
	MinusOutlined,
	MoreOutlined,
	ArrowsAltOutlined,
	ShrinkOutlined,
} from '@ant-design/icons';
import {
	XButtonBack,
	XEditTitle,
	XRadio,
	XThemMainTitle,
	SubTitle,
	ParagraphPage,
	XThemeAddressWrap,
	XCardSupportingDocument,
	XThemeCardCaseOperations,
	XThemeAvatarName,
	XThemeCardSummaryEdit,
	XThemeCardSupportingDocument,
	XThemeMobileCaseDetailsHeader,
	XThemeMobileTimeVHistoryWrapper,
	XThemeAvatarText,
	XThemeMotionMode,
} from '../../pages/CaseForm/CaseFormStyle';
import {
	XDivider,
	XPara1,
	XTitleHead,
	XLottieMargin,
	Title,
	XCardsGrdBG,
	XButtonAdd,
	XButtonLike,
	XLottieOverlay,
	XButtonConfirm,
	XNotificationBar,
	XButtonReload,
	XButtonCloseBar,
	XCheckboxGroup,
	XRecommendedCard,
	XInputText,
	XViewMoreBTN,
	XRecommendedMobCard,
	XMobDropdown,
	XMobWrap,
	XSupportingDocument,
	XDesktopCaseFillingDropdown,
	XDesktopActionCard,
} from '../../pages/AnalyseCoverage/AnalyseCoverageStyle';
import {
	XCardSummaryEdit,
	XCardsCaseBg,
	XRoundButton,
	XList,
	XCircle,
	XLabel,
	XModalTitle,
	XModalSubtitle,
	XContainer,
	XTag,
	XThemeTag,
	XForm,
	XThemeFilterButton,
	XThemeButton,
	XThemeModal,
	XThemeSelect,
	XThemeInputText,
	XThemeFilterCircleButton,
} from '../../styles/GlobalThemeStyle';
import { XButtonImg } from '../../pages/Manage/ManageStyle';
import { getUserToken, toTitleCase } from '../../utils/helper';
import config from '../../config';

import { reviseCoverageReset } from '../../actions/reviseCoverageAction';
import { handleInputChange } from '../../utils/formFunctions';
import dayjs from 'dayjs';
import {
	XActionBtns,
	XActionPlay,
	XCardDesktop,
} from '../../pages/AipaNew/NewAipaStyle';
import WaveformVisualizer from './RecorderWave';
import { AipaAudioBtn } from '../../pages/Aipa/AipaStyle';
import {
	Theme,
	XTheme2Button,
	XTheme2Form,
	XTheme2MainTitle2,
	XTheme2Select,
	XTheme2TableCircleTag,
} from '../../styles/GlobalThemeStyleCQ';
import CardCodingTools from '../CodingTools/CardCodingTools';
import { motion, AnimatePresence } from 'framer-motion';
const { TextArea } = Input;
const { Dragger } = Upload;

const items = [
	{
		label: 'Edit',
		key: '1',
		icon: <EditOutlined />,
	},
	{
		type: 'divider',
	},
	{
		label: 'Delete',
		key: '2',
		icon: <DeleteOutlined />,
	},
];

const CaseOperations = (props) => {
	const {
		patientData,
		mainDataLoading,
		handleClinicalDocsChange = () => {},
		clinicalDocumentFileList,
		clinicalDocsForm,
		clinicalDocsLoading,
		handleUploadCancel = () => {},
		setIsClinicalUploadModalOpen,
		isClinicalUploadModalOpen,
		setPreviewImage,
		previewImage,
		setPreviewTitle,
		previewTitle,
		setPdfPreviewOpen,
		pdfPreviewOpen,
		documentsToDisplay,
		clinicalSummaryTextLoading,
		setClinicalSummaryTextLoading,
		showClinicalTextArea,
		setShowClinicalTextArea,
		id,
		editCase = () => {},
		handleRemoveClinicalDocuments = () => {},
		setPageContent,
		pageContent,
		clinicalDocumentsToDisplay,
		feedbackId,
		reviseCoverage,
		lastAnalysisData,
		setLoading,
		loading,
		getBase64 = () => {},
		setClinicalDocsLoading,
		setSubmitClinicalDocs,
		setUpdatedClinicalDocumentFileList,
		form,
		setModalTextArea,
		setModalOpen,
		handleCodeClick = () => {},
		handleClinicalSummaryDoc = () => {},
		modalOpen,
		sendFeedback,
		sendFeedbackState,
		modalTextArea,
		updatePageContent,
		missingFieldsForm,
		missingFieldsCardRef,
		handleAddOption,
		missingFields,
		missingFieldInstructions,
		setMissingFieldsModal,
		setMissingFieldInstructions,
		setMissingFields,
		missingFieldTitle,
		missingFieldsModal,
		isOpenAnalysis,
		supportingDocsSummary,
		summary,
		setSummary,
		provider,
		state,
		dateOfBirth = () => {},
		matchGender,
		previewMode,
		aipa,
		currentRevision,
		checkCoverage,
		clinicalAudioToDisplay,
		isClinicalUploadAudioModalOpen,
		setIsClinicalUploadAudioModalOpen,
		audioBlob,
		recordingTime,
		isRecording,
		isPlaying,
		audioElementRef,
		isPaused,
		handleStop,
		handleResume,
		handlePause,
		handleDone,
		toggleDictation,
		handlePausePlayback,
		handlePlayRecording,
		handleRemoveClinicalAudios = () => {},
		handleUploadAudioCancel = () => {},
		handleClinicalSummaryAudio = () => {},
		audioPlayModal,
		setAudioPlayModal,
		fileToPlay,
		setFileToPlay,
		handlePlayRecordedNote,
		clinicalAudioForm,
		setRecordingTime,
		selectedProvider,
		selectedModel,
		revenueCycle,
	} = props;

	const [clinicalForm] = XTheme2Form.useForm();
	const [previewOpen, setPreviewOpen] = useState(false);
	const [pdfWidth, setPdfWidth] = useState(700);
	const [coverage, setCoverage] = useState('Yes');
	const [formData, setFormData] = useState();
	const [expandedStates, setExpandedStates] = useState([]);
	const [mainExpanded, setMainExpanded] = useState(false);

	// Add these refs at component level
	const contentRefs = useRef([]);
	const mainContentRef = useRef(null);
	const editorRef = useRef(null);
	const [editorContent, setEditorContent] = useState('');
	// Add to your existing refs
	const clinicalSummaryRef = useRef(null);
	const [clinicalExpanded, setClinicalExpanded] = useState(false);

	// Initialize expandedStates when documentsToDisplay changes
	useEffect(() => {
		if (documentsToDisplay?.length) {
			setExpandedStates(new Array(documentsToDisplay.length).fill(false));
		}
	}, [documentsToDisplay]);

	useEffect(() => {
		return () => {
			if (editorRef.current) {
				editorRef.current = null;
			}
			setEditorContent('');
			clinicalForm.resetFields();
		};
	}, []);

	const handleClinicalDocsUpload = async () => {
		try {
			if (isOpenAnalysis) {
				await clinicalDocsForm.validateFields(['clinical_docs']); // Await validation
				setClinicalDocsLoading(true);
				handleClinicalSummaryDoc();
			} else {
				clinicalDocsForm
					.validateFields()
					.then(async () => {
						if (clinicalDocumentFileList.length > 0) {
							setClinicalDocsLoading(true);
							await Promise.all(
								clinicalDocumentFileList.map(
									async (fileData) => {
										let get_ext =
											fileData.originFileObj.name.split(
												'.',
											);
										let ext = get_ext[get_ext.length - 1];
										const res = await axios.get(
											// `${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=original_documents&file_name=denial_letter&ext=pdf&id=denial_letter`,
											`${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=clinical_documents&file_name=${patientData.patient_last_name}${fileData.originFileObj.uid}&ext=${ext}&id=${patientData.case_id}`,
											{
												headers: {
													'Content-type':
														'application/json; charset=UTF-8',
													Authorization:
														'Bearer ' +
														getUserToken(),
												},
											},
										);

										const result = await axios.put(
											res.data.data,
											fileData.originFileObj,
										);

										if (result.status === 200) {
											// const documentPath = `/original_documents/denial_letter/denial_letter.pdf`;
											const documentPath = `/clinical_documents/${patientData.case_id}/${patientData.patient_last_name}${fileData.originFileObj.uid}.${ext}`;
											const newFile = {
												uid: fileData.originFileObj.uid,
												name: fileData.originFileObj
													.name,
												status: 'done',
												url: documentPath,
											};
											setUpdatedClinicalDocumentFileList(
												(prevFileList) => [
													{ url: newFile },
												],
											);
										}
									},
								),
							).then((res) => {
								setSubmitClinicalDocs(true);
							});
						}
						setSubmitClinicalDocs(true);
					})
					.catch((err) => {
						setClinicalDocsLoading(false);
					});
			}
		} catch (error) {
			setSubmitClinicalDocs(false);
			// Handle error if any
			// notification.success({
			// 	message: 'Could not upload',
			// });
			setClinicalDocsLoading(false);
			console.error('Error occurred:', error);
		}
	};

	const handleClinicalAudioUpload = async () => {
		try {
			if (isOpenAnalysis) {
				await clinicalAudioForm.validateFields(['dictate_audio_note']);
				setClinicalDocsLoading(true);
				handleClinicalSummaryAudio();
			}
		} catch (error) {
			// Handle error if any
			// notification.success({
			// 	message: 'Could not upload',
			// });
			setClinicalDocsLoading(false);
			console.error('Error occurred:', error);
		}
	};

	const handlePlayAudioCancel = () => {
		setAudioPlayModal(false);
		handleUploadAudioCancel();
		setFileToPlay(null);
	};

	const capitalizeFirstLetter = (string) => {
		if (!string) return string; // Return the string if it's null or undefined
		return string.charAt(0).toUpperCase() + string.slice(1);
	};

	//Clinical Docs Upload
	const showClinicalModal = () => {
		setIsClinicalUploadModalOpen(true);
	};

	const handlePreview = async (file) => {
		if (
			file &&
			file.name &&
			file.url &&
			file.name.split('.').includes('pdf')
		) {
			setPreviewImage(`${config.s3_url}${file.url}` || file.preview);
			setPdfPreviewOpen(true);
		} else {
			if (
				!file.url &&
				!file.preview &&
				file.name.split('.').includes('pdf')
			) {
				file.preview = await getBase64(file.originFileObj);
			}

			setPreviewImage(file.preview);
			setPdfPreviewOpen(true);
			setPreviewTitle(
				file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
			);
		}
	};

	const handlePlayAudio = async (file) => {
		setAudioPlayModal(true);
		setFileToPlay(`${config.s3_url}${file.url}`);
		const response = await fetch(`${config.s3_url}${file.url}`);
		const arrayBuffer = await response.arrayBuffer();

		const audioContext = new (window.AudioContext ||
			window.webkitAudioContext)();
		const decodedData = await audioContext.decodeAudioData(arrayBuffer);

		const totalDuration = decodedData.duration;
		const minutes = String(Math.floor(totalDuration / 60)).padStart(2, '0');
		const seconds = String(Math.floor(totalDuration % 60)).padStart(2, '0');
		setRecordingTime(`${minutes}:${seconds}`);
	};

	const showClinicalDelete = (title, file) => {
		XThemeModal.confirm({
			title: `Delete ${title}?`,
			content: (
				<p className="modalPara1">
					Are you sure you want to delete - {title}?
				</p>
			),
			icon: (
				<span className="modalTitleIcon">
					<img src="/images/delete-modal-icon.svg" alt="delete" />
				</span>
			),
			okText: 'Yes, Confirm',
			okType: 'danger',
			cancelButtonProps: {
				className: 'xThemeCancelSubmit',
			},
			okButtonProps: {
				className: 'xThemeButtonSubmit',
			},
			cancelText: 'No, Cancel',
			// className: 'confirmModal',
			onOk: async () => {
				// Make an API call to delete the file from S3 and your collection
				try {
					// Extract file name and extension from the file URL
					const urlParts = file.url.split('/');
					const fileName = urlParts[urlParts.length - 1];
					const case_id = urlParts[urlParts.length - 2];
					const [patientName, ext] = fileName.split('.');

					// Make API calls to delete the file from S3 and collection
					await axios.delete(
						`${config.api.base_url}/settings/delete-signed-url?folder_name=clinical_documents&file_name=${patientName}&ext=${ext}&id=${case_id}`,
						{
							headers: {
								Authorization: 'Bearer ' + getUserToken(),
							},
						},
					);

					// Remove the file from supporting_docs array
					const updatedClinicalDocs =
						clinicalDocumentsToDisplay.filter(
							(item) => item.url.uid === file.uid,
						);

					// Make API call to update the supporting_docs field in your case
					await editCase({
						id: id,
						deleted_clinical_docs: updatedClinicalDocs,
						remove: true,
						singleDelete: true,
					});

					console.log(
						'File deleted successfully from S3 and collection',
					);
				} catch (error) {
					console.error('Error deleting file:', error);
					// Handle error
				}
			},
			onCancel() {
				console.log('Cancel');
			},
		});
	};

	const deletePageContent = (item, id) => {
		const updatedPageContent = { ...pageContent };
		updatedPageContent[[item]].splice(id, 1);
		setPageContent(updatedPageContent);
		setModalOpen([false, '', ' ']);
		setModalTextArea('');
		form.resetFields();
		document.getElementById('notification')?.classList.remove('d-none');
	};

	const showDeleteConfirm = (title, id, content, item) => {
		XThemeModal.confirm({
			title: `Delete ${title}?`,
			content: (
				<p className="modalPara1">
					Are you sure you want to delete - {content}?
				</p>
			),
			icon: (
				<span className="modalTitleIcon">
					<img src="/images/delete-modal-icon.svg" alt="delete" />
				</span>
			),
			okText: 'Yes, Confirm',
			okType: 'danger',
			cancelText: 'No, Cancel',
			// className: 'confirmModal',
			cancelButtonProps: {
				className: 'xThemeCancelSubmit',
			},
			okButtonProps: {
				className: 'xThemeButtonSubmit',
			},
			onOk() {
				deletePageContent(item, id);
			},
			onCancel() {
				console.log('Cancel');
			},
		});
	};
	// const [showMobileTimeline, setShowMobileTimeline] = useState(false);
	// const [showMobileVHistory, setShowMobileVHistory] = useState(false);

	// const showMobileTimelineCard = () => {
	// 	setShowMobileTimeline(true);
	// };

	// const showMobileVHistoryCard = () => {
	// 	setShowMobileVHistory(true);
	// };

	// const closeCard = () => {
	// 	setShowMobileTimeline(false);
	// 	setShowMobileVHistory(false);
	// };
	//const [expendProfile, setExpendProfile] = useState(false);
	// const handleExpendProfile = () => {
	// 	setClinicalExpanded(!clinicalExpanded);
	// 	if (clinicalExpanded) {
	// 		document.body.classList.remove('bodyBlockScroll');
	// 	} else {
	// 		document.body.classList.add('bodyBlockScroll');
	// 	}
	// };
	const handleExpandedStates = () => {
		setExpandedStates(!expandedStates);
		if (expandedStates) {
			document.body.classList.add('bodyBlockScroll');
		} else {
			document.body.classList.remove('bodyBlockScroll');
		}
	};

	const [detailsFullscreenOpen, setDetailsFullscreenOpen] = useState(false);
	const triggerRef = useRef(null);
	const handleFullscreenOpen = () => {
		setDetailsFullscreenOpen(true);
		document.body.classList.add('hideMinContent');
	};
	const handleFullscreenClose = () => {
		setDetailsFullscreenOpen(false);
		document.body.classList.remove('hideMinContent');
		console.log('handleFullscreenClose');
	};

	const [summaryFullscreenOpen, setSummaryFullscreenOpen] = useState(false);
	const triggerSummaryRef = useRef(null);
	const handleSummaryFullscreenOpen = () => {
		setSummaryFullscreenOpen(true);
		document.body.classList.add('hideMinContent');
	};
	const handleSummaryFullscreenClose = () => {
		setSummaryFullscreenOpen(false);
		document.body.classList.remove('hideMinContent');
		console.log('handleFullscreenClose');
	};

	const [summaryMultipleFullscreenOpen, setSummaryMultipleFullscreenOpen] =
		useState(false);

	const triggerSummaryMultipleRef = useRef(null);
	const handleSummaryMultipleFullscreenOpen = () => {
		setSummaryMultipleFullscreenOpen(true);
		//document.body.classList.add('hideMinContent');
		console.log('handleSummaryMultipleFullscreenOpen........');
	};
	const handleSummaryMultipleFullscreenClose = () => {
		setSummaryMultipleFullscreenOpen(false);
		//document.body.classList.remove('hideMinContent');
	};

	return (
		<>
			<Row gutter={[15, 15]}>
				{/* Clinical Summary */}
				{/* {isOpenAnalysis ? (
				<></>
			) : ( */}

				<Col
					xs={24}
					sm={24}
					lg={
						patientData?.summary_docs || supportingDocsSummary
							? 24
							: 12
					}
				>
					<XThemeCardCaseOperations
						className="haveHeader bgColorClinical"
						// className={
						// 	clinicalExpanded
						// 		? 'haveHeader bgColorClinical fullScreen'
						// 		: 'haveHeader bgColorClinical'
						// }
						title={
							<Row
								gutter={[15, 15]}
								className="align-items-center"
							>
								<Col xs={12} sm={12} lg={12}>
									<Space align="center">
										<img
											className="iconResp"
											src="/images/clinical-summary-icon.svg"
											alt=""
										/>
										<XTitleHead>
											<div className="titleHeading">
												Detailed Clinical Overview
											</div>
										</XTitleHead>
									</Space>
								</Col>
								<Col
									xs={12}
									sm={12}
									lg={12}
									className="text-end"
								>
									<div className="showMobile text-end">
										<Space direction="horizontal">
											<>
												{!showClinicalTextArea &&
													!previewMode && (
														<XButtonConfirm
															type="text"
															icon={
																<img
																	src="/images/edit-clinical-icon.svg"
																	style={{
																		width: '20px',
																	}}
																	alt="Edit"
																/>
															}
															onClick={() => {
																setShowClinicalTextArea(
																	true,
																);
																clinicalForm.setFieldsValue(
																	{
																		clinical_summary:
																			isOpenAnalysis
																				? summary
																				: patientData.clinical_summary,
																	},
																);
															}}
															style={{
																background:
																	'#fff',
															}}
														/>
													)}
												{clinicalDocumentsToDisplay &&
												clinicalDocumentsToDisplay.length >
													0 ? (
													<>
														{clinicalDocumentsToDisplay &&
															clinicalDocumentsToDisplay.length >
																0 &&
															clinicalDocumentsToDisplay.map(
																(ele) => {
																	return (
																		<>
																			{(isOpenAnalysis
																				? ele?.name
																				: ele
																						?.url
																						.name
																			)
																				.split(
																					'.',
																				)
																				.includes(
																					'pdf',
																				) && (
																				<>
																					<XButtonConfirm
																						type="text"
																						icon={
																							<img
																								src="/images/pdf-new-icon.svg"
																								style={{
																									width: '20px',
																								}}
																								alt="delete"
																							/>
																						}
																						style={{
																							background:
																								'#fff',
																						}}
																						onClick={() =>
																							isOpenAnalysis
																								? handlePreview(
																										ele,
																								  )
																								: handlePreview(
																										ele.url,
																								  )
																						}
																					/>
																					{!previewMode && (
																						<XButtonConfirm
																							type="text"
																							icon={
																								<img
																									src="/images/delete-icon-new.svg"
																									style={{
																										width: '20px',
																									}}
																									alt="delete"
																								/>
																							}
																							style={{
																								background:
																									'#fff',
																							}}
																							onClick={() => {
																								isOpenAnalysis
																									? handleRemoveClinicalDocuments(
																											ele,
																									  )
																									: showClinicalDelete(
																											'Clinical Summary Document',
																											ele.url,
																									  );
																							}}
																						/>
																					)}
																				</>
																			)}
																		</>
																	);
																},
															)}
													</>
												) : (
													<>
														{aipa
															? !previewMode &&
															  clinicalAudioToDisplay &&
															  clinicalAudioToDisplay.length ===
																	0 && (
																	<XButtonAdd
																		onClick={() => {
																			showClinicalModal();
																		}}
																		icon={
																			<PlusOutlined />
																		}
																	></XButtonAdd>
															  )
															: !previewMode && (
																	<XButtonAdd
																		onClick={() => {
																			showClinicalModal();
																		}}
																		icon={
																			<PlusOutlined />
																		}
																	></XButtonAdd>
															  )}
														{/* {!previewMode && (
												<XButtonAdd
													onClick={() => {
														showClinicalModal();
													}}
													icon={<PlusOutlined />}
												></XButtonAdd>
											)} */}
													</>
												)}
												{/* added audio code start */}
												{clinicalAudioToDisplay &&
												clinicalAudioToDisplay.length >
													0 ? (
													<>
														{clinicalAudioToDisplay &&
															clinicalAudioToDisplay.length >
																0 &&
															clinicalAudioToDisplay.map(
																(ele) => {
																	return (
																		<>
																			{(isOpenAnalysis
																				? ele?.url
																				: ele?.url
																			)
																				.split(
																					'.',
																				)
																				.includes(
																					'wav',
																				) && (
																				<>
																					<XButtonConfirm
																						type="primary"
																						// size="large"
																						// shape="round"
																						icon={
																							<PlayCircleOutlined />
																						}
																						// className="btnActive mb-2 mb-md-0 mb-sm-0"
																						onClick={() =>
																							isOpenAnalysis
																								? handlePlayAudio(
																										ele,
																								  )
																								: handlePreview(
																										ele.url,
																								  )
																						}
																					>
																						{/* Clinical
																			audio */}
																					</XButtonConfirm>
																					{!previewMode && (
																						<XButtonConfirm
																							disabled={
																								currentRevision?.field ===
																								'clinical_summary'
																							}
																							icon={
																								<img
																									src="/images/delete-icon-new.svg"
																									alt="Delete"
																								/>
																							}
																							type="primary"
																							// size="large"
																							// shape="round"
																							style={{
																								background:
																									'#fff',
																							}}
																							onClick={() => {
																								isOpenAnalysis
																									? handleRemoveClinicalAudios(
																											ele,
																									  )
																									: showClinicalDelete(
																											'Clinical Summary Document',
																											ele.url,
																									  );
																							}}
																						>
																							{/* Delete */}
																						</XButtonConfirm>
																					)}
																				</>
																			)}
																		</>
																	);
																},
															)}
													</>
												) : (
													<>
														{!previewMode &&
															aipa &&
															clinicalDocumentsToDisplay &&
															clinicalDocumentsToDisplay?.length ===
																0 && (
																<XButtonAdd
																	onClick={() => {
																		setIsClinicalUploadAudioModalOpen(
																			true,
																		);
																	}}
																	icon={
																		<AudioOutlined />
																	}
																></XButtonAdd>
															)}
													</>
												)}
												{/* added sudio code end */}
											</>
										</Space>
									</div>
									{currentRevision?.field ===
									'clinical_summary' ? (
										<></>
									) : (
										<Space className="d-md-inline-flex showDesktop">
											{!showClinicalTextArea &&
												!previewMode && (
													<Tooltip
														title="Edit"
														color={
															Theme.CQColors
																.secondaryColor
														}
													>
														<XButtonConfirm
															disabled={
																currentRevision?.field ===
																'clinical_summary'
															}
															icon={
																<img
																	src="/images/edit-clinical-icon.svg"
																	style={{
																		width: '20px',
																	}}
																	alt="Edit"
																/>
															}
															className="mb-2 mb-md-0 mb-sm-0"
															type="primary"
															size="middle"
															shape="square"
															iconPosition="end"
															style={{
																background:
																	'#fff',
															}}
															onClick={() => {
																setShowClinicalTextArea(
																	true,
																);
																clinicalForm.setFieldsValue(
																	{
																		clinical_summary:
																			isOpenAnalysis
																				? summary
																				: patientData.clinical_summary,
																	},
																);
															}}
														/>
													</Tooltip>
												)}
											{clinicalDocumentsToDisplay &&
											clinicalDocumentsToDisplay.length >
												0 ? (
												<>
													{clinicalDocumentsToDisplay &&
														clinicalDocumentsToDisplay.length >
															0 &&
														clinicalDocumentsToDisplay.map(
															(ele) => {
																return (
																	<>
																		{(isOpenAnalysis
																			? ele?.name
																			: ele
																					?.url
																					.name
																		)
																			.split(
																				'.',
																			)
																			.includes(
																				'pdf',
																			) && (
																			<>
																				<Tooltip
																					title="Clinical Document"
																					color={
																						Theme
																							.CQColors
																							.secondaryColor
																					}
																				>
																					<XButtonConfirm
																						type="primary"
																						size="middle"
																						shape="square"
																						iconPosition="end"
																						icon={
																							<img
																								src="/images/pdf-icon.svg"
																								style={{
																									width: '20px',
																								}}
																								alt="Edit"
																							/>
																						}
																						className="btnActive mb-2 mb-md-0 mb-sm-0"
																						onClick={() =>
																							isOpenAnalysis
																								? handlePreview(
																										ele,
																								  )
																								: handlePreview(
																										ele.url,
																								  )
																						}
																					/>
																				</Tooltip>
																				{!previewMode && (
																					<Tooltip
																						title="Delete"
																						color={
																							Theme
																								.CQColors
																								.secondaryColor
																						}
																					>
																						<XButtonConfirm
																							disabled={
																								currentRevision?.field ===
																								'clinical_summary'
																							}
																							icon={
																								<img
																									src="/images/delete-icon-new.svg"
																									alt="Delete"
																								/>
																							}
																							type="primary"
																							size="middle"
																							shape="square"
																							iconPosition="end"
																							style={{
																								background:
																									'#fff',
																							}}
																							onClick={() => {
																								isOpenAnalysis
																									? handleRemoveClinicalDocuments(
																											ele,
																									  )
																									: showClinicalDelete(
																											'Clinical Summary Document',
																											ele.url,
																									  );
																							}}
																						/>
																					</Tooltip>
																				)}
																			</>
																		)}
																	</>
																);
															},
														)}
												</>
											) : (
												<>
													{aipa
														? !previewMode &&
														  clinicalAudioToDisplay &&
														  clinicalAudioToDisplay.length ===
																0 && (
																<Tooltip
																	title="Add"
																	color={
																		Theme
																			.CQColors
																			.secondaryColor
																	}
																>
																	<XButtonAdd
																		onClick={() => {
																			showClinicalModal();
																		}}
																		icon={
																			<PlusOutlined />
																		}
																		size="middle"
																		shape="square"
																		iconPosition="end"
																	/>
																</Tooltip>
														  )
														: !previewMode && (
																<Tooltip
																	title="Add"
																	color={
																		Theme
																			.CQColors
																			.secondaryColor
																	}
																>
																	<XButtonAdd
																		onClick={() => {
																			showClinicalModal();
																		}}
																		icon={
																			<PlusOutlined />
																		}
																		size="middle"
																		shape="square"
																		iconPosition="end"
																	/>
																</Tooltip>
														  )}
													{/* {!previewMode && (
											<XButtonAdd
												onClick={() => {
													showClinicalModal();
												}}
												icon={<PlusOutlined />}
											></XButtonAdd>
										)} */}
												</>
											)}
											{/* added audio code start */}
											{clinicalAudioToDisplay &&
											clinicalAudioToDisplay.length >
												0 ? (
												<>
													{clinicalAudioToDisplay &&
														clinicalAudioToDisplay.length >
															0 &&
														clinicalAudioToDisplay.map(
															(ele) => {
																return (
																	<>
																		{(isOpenAnalysis
																			? ele?.url
																			: ele?.url
																		)
																			.split(
																				'.',
																			)
																			.includes(
																				'wav',
																			) && (
																			<>
																				<Tooltip
																					title="Clinical Audio"
																					color={
																						Theme
																							.CQColors
																							.secondaryColor
																					}
																				>
																					<XButtonConfirm
																						type="primary"
																						size="middle"
																						shape="square"
																						iconPosition="end"
																						icon={
																							<PlayCircleOutlined />
																						}
																						className="btnActive mb-2 mb-md-0 mb-sm-0"
																						onClick={() =>
																							isOpenAnalysis
																								? handlePlayAudio(
																										ele,
																								  )
																								: handlePreview(
																										ele.url,
																								  )
																						}
																					/>
																				</Tooltip>
																				{!previewMode && (
																					<Tooltip
																						title="Delete"
																						color={
																							Theme
																								.CQColors
																								.secondaryColor
																						}
																					>
																						<XButtonConfirm
																							disabled={
																								currentRevision?.field ===
																								'clinical_summary'
																							}
																							icon={
																								<img
																									src="/images/delete-icon-new.svg"
																									alt="Delete"
																								/>
																							}
																							type="primary"
																							size="large"
																							shape="round"
																							style={{
																								background:
																									'#fff',
																							}}
																							onClick={() => {
																								isOpenAnalysis
																									? handleRemoveClinicalAudios(
																											ele,
																									  )
																									: showClinicalDelete(
																											'Clinical Summary Document',
																											ele.url,
																									  );
																							}}
																						/>
																					</Tooltip>
																				)}
																			</>
																		)}
																	</>
																);
															},
														)}
												</>
											) : (
												<>
													{!previewMode &&
														aipa &&
														clinicalDocumentsToDisplay &&
														clinicalDocumentsToDisplay?.length ===
															0 && (
															<Tooltip
																title="Add"
																color={
																	Theme
																		.CQColors
																		.secondaryColor
																}
															>
																<XButtonAdd
																	onClick={() => {
																		setIsClinicalUploadAudioModalOpen(
																			true,
																		);
																	}}
																	icon={
																		<AudioOutlined />
																	}
																	size="middle"
																	shape="square"
																	iconPosition="end"
																/>
															</Tooltip>
														)}
												</>
											)}
											{/* added sudio code end */}
											<Tooltip
												title="Expand"
												color={
													Theme.CQColors
														.secondaryColor
												}
											>
												<XButtonConfirm
													size="middle"
													shape="circle"
													ref={triggerRef}
													layoutId="morphingModalDetails"
													className="motionOpenBtn"
													onClick={
														handleFullscreenOpen
													}
													icon={<ArrowsAltOutlined />}
													iconPosition="end"
												/>
											</Tooltip>
										</Space>
									)}
								</Col>
							</Row>
						}
					>
						<XThemeCardSummaryEdit className="mb-3">
							<Row className="align-items-center">
								{!showClinicalTextArea ? (
									<Col xs={24} lg={24}>
										<>
											<div className="para text-justify">
												{currentRevision?.field ===
												'clinical_summary' ? (
													<div
														// className={`content-wrapper ${
														// 	clinicalExpanded
														// 		? 'expanded'
														// 		: ''
														// }`}
														className="content-wrapper"
														style={{
															maxHeight:
																clinicalExpanded
																	? 'none'
																	: '260px',
															overflow: 'hidden',
															position:
																'relative',
														}}
													>
														<div
															ref={
																clinicalSummaryRef
															}
															dangerouslySetInnerHTML={{
																__html: currentRevision?.finalValue,
															}}
														/>

														{!clinicalExpanded &&
															clinicalSummaryRef
																.current
																?.scrollHeight >
																260 && (
																<div
																	style={{
																		position:
																			'absolute',
																		bottom: 0,
																		left: 0,
																		right: 0,
																		height: '50px',
																		background:
																			'linear-gradient(transparent, white)',
																	}}
																/>
															)}
													</div>
												) : (
													<div
														// className={`content-wrapper ${
														// 	clinicalExpanded
														// 		? 'expanded'
														// 		: ''
														// }`}
														className="content-wrapper"
														style={{
															maxHeight:
																clinicalExpanded
																	? 'none'
																	: '260px',
															overflow: 'hidden',
															position:
																'relative',
														}}
													>
														<div
															ref={
																clinicalSummaryRef
															}
															dangerouslySetInnerHTML={{
																__html: isOpenAnalysis
																	? summary
																	: patientData.clinical_summary,
															}}
														/>
														<XThemeMotionMode>
															<AnimatePresence mode="wait">
																{detailsFullscreenOpen && (
																	<div
																		className="motionAnimateWrapper"
																		style={{
																			marginLeft:
																				window.innerWidth <=
																				991
																					? 0
																					: props.collapsed
																					? 80
																					: 210,
																			width:
																				window.innerWidth <=
																				991
																					? '100%'
																					: props.collapsed
																					? 'calc(100% - 80px)'
																					: 'calc(100% - 210px)',
																		}}
																	>
																		{/* Backdrop - covers the entire main content area */}
																		<motion.div
																			className="motionBackdrop"
																			onClick={
																				handleFullscreenClose
																			}
																		/>
																		{/* Modal Content - morphs from the trigger div */}
																		<motion.div
																			layoutId="morphingModalDetails"
																			initial={{
																				opacity: 0,
																				scale: 0,
																			}}
																			animate={{
																				opacity: 1,
																				scale: 1,
																			}}
																			exit={{
																				opacity: 0,
																				scale: 0,
																			}}
																			className="motionContent"
																		>
																			{/* Close button */}
																			<XTheme2Button
																				icon={
																					<CloseOutlined />
																				}
																				onClick={
																					handleFullscreenClose
																				}
																				size="large"
																				shape="circle"
																				className="motionCloseBtn"
																			/>
																			<div
																				ref={
																					clinicalSummaryRef
																				}
																				dangerouslySetInnerHTML={{
																					__html: isOpenAnalysis
																						? summary
																						: patientData.clinical_summary,
																				}}
																			/>
																		</motion.div>
																	</div>
																)}
															</AnimatePresence>
														</XThemeMotionMode>
														{!clinicalExpanded &&
															clinicalSummaryRef
																.current
																?.scrollHeight >
																260 && (
																<div
																	style={{
																		position:
																			'absolute',
																		bottom: 0,
																		left: 0,
																		right: 0,
																		height: '50px',
																		background:
																			'linear-gradient(transparent, white)',
																	}}
																/>
															)}
													</div>
												)}
											</div>
											{/* {clinicalSummaryRef.current
												?.scrollHeight > 260 && ( */}
											<div
												// onClick={() =>
												// 	setClinicalExpanded(
												// 		!clinicalExpanded,
												// 	)
												// }
												onClick={handleFullscreenOpen}
												ref={triggerRef}
												layoutId="morphingModalDetails"
												className="readMore"
											>
												{/* {clinicalExpanded
														? 'Read Less'
														: 'Read More'} */}
												Read More
											</div>
											{/* )} */}
										</>
									</Col>
								) : (
									<>
										<Form
											form={clinicalForm}
											onFinish={(values) => {
												const content =
													editorRef.current
														? editorRef.current.getContent()
														: '';
												setClinicalSummaryTextLoading(
													true,
												);
												// add logic for open analysis
												// Check if open analysis is true
												if (isOpenAnalysis) {
													updatePageContent(
														'originalQuery',
														null,
														content,
													);
												} else {
													editCase({
														id,
														...values,
														clinical_summary:
															content,
													});
												}
											}}
											className="w-100"
										>
											<Col xs={24} className="text-end">
												<XTheme2Form.Item
													name="clinical_summary"
													className="drawerlabel mb-0"
													rules={[
														{
															required: true,
															message:
																'Please enter clinical summary',
														},
													]}
												>
													<Editor
														apiKey={
															config.tiny_url_key
														}
														onInit={(
															evt,
															editor,
														) => {
															editorRef.current =
																editor;
															const initialContent =
																isOpenAnalysis
																	? summary
																	: patientData?.clinical_summary;
															if (
																initialContent
															) {
																editor.setContent(
																	initialContent,
																);
																setEditorContent(
																	initialContent,
																);
															}
														}}
														init={{
															menubar: false,
															plugins: [
																'code',
																'image',
																'link',
																'visualblocks',
															],
															branding: false,
															toolbar:
																'undo redo | formatselect | ' +
																'bold italic backcolor | alignleft aligncenter alignright alignjustify | blocks fontfamily fontsize | ' +
																'bullist numlist outdent indent | image link |' +
																'removeformat | visualblocks code | help ',
															content_style:
																'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
															font_size_formats:
																'8px 10px 12px 14px 18px 24px 36px',
															forced_root_block:
																'p',
															entity_encoding:
																'raw',
															height: 300,
															setup: function (
																editor,
															) {
																editor.on(
																	'BeforeSetContent',
																	function (
																		e,
																	) {
																		if (
																			e.content ===
																				null ||
																			e.content ===
																				undefined
																		) {
																			e.content =
																				'';
																		}
																	},
																);
															},
														}}
														onEditorChange={(
															content,
															editor,
														) => {
															setEditorContent(
																content,
															);

															if (
																isOpenAnalysis
															) {
																setSummary(
																	content,
																);
															}
															clinicalForm.setFieldsValue(
																{
																	clinical_summary:
																		content,
																},
															);
															if (
																handleInputChange
															) {
																handleInputChange(
																	{
																		target: {
																			name: 'clinical_summary',
																			value: content,
																		},
																	},
																	formData,
																	setFormData,
																);
															}
														}}
													/>
												</XTheme2Form.Item>
											</Col>
											<Col
												xs={24}
												className="text-end mt-2"
											>
												<XTheme2Button
													className="noBackground me-3"
													onClick={() => {
														setShowClinicalTextArea(
															false,
														);
													}}
												>
													Cancel
												</XTheme2Button>
												<XTheme2Button
													loading={
														clinicalSummaryTextLoading
													}
													type="primary"
													htmlType="submit"
												>
													Submit
												</XTheme2Button>
											</Col>
										</Form>
									</>
								)}
							</Row>
						</XThemeCardSummaryEdit>
						{/* {isOpenAnalysis ? (
					<></>
				) : ( */}
					</XThemeCardCaseOperations>
					{/* )} */}
					{/* Clinical Summary Upload */}
					<Modal
						// title="Upload Clinical Document"
						title={
							<>
								<span className="modalTitleIcon">
									<img
										src="/images/upload-modal-icon.svg"
										alt="Upload"
									/>
								</span>
								Upload Clinical Document
							</>
						}
						open={isClinicalUploadModalOpen}
						onOk={handleClinicalDocsUpload}
						okButtonProps={{
							loading: clinicalDocsLoading,
							className: 'xThemeButtonSubmit',
						}}
						cancelButtonProps={{
							className: 'xThemeCancelSubmit',
						}}
						onCancel={() => {
							if (!clinicalDocsLoading) {
								clinicalDocsForm.resetFields();
								handleUploadCancel();
							}
						}}
					>
						<XTheme2Form
							form={clinicalDocsForm}
							layout="vertical"
							autoComplete="off"
						>
							<XTheme2Form.Item
								name="clinical_docs"
								className="mt-4"
								rules={[
									{
										required: true,
										validator: (_, value) => {
											if (
												clinicalDocumentFileList.length ===
												0
											) {
												return Promise.reject(
													new Error(
														'Please Select file!',
													),
												);
											}
											return Promise.resolve();
										},
									},
								]}
							>
								<Dragger
									fileList={clinicalDocumentFileList}
									maxCount={1}
									beforeUpload={(file) => {
										const isJPEG =
											file.type === 'image/jpeg';
										const isJPG = file.type === 'image/jpg';
										const isPNG = file.type === 'image/png';
										const isGIF = file.type === 'image/gif';
										const isVideo =
											file.type.startsWith('video/');
										const isAudio =
											file.type.startsWith('audio/');

										const isLt10M =
											file.size / 1024 / 1024 < 10;

										if (!isLt10M) {
											notification.error({
												message: 'File Size Exceeded',
												description: `The file ${file.name} exceeds the maximum allowed size of 10MB.`,
											});
										}
										if (
											isGIF ||
											isVideo ||
											isAudio ||
											isJPEG ||
											isJPG ||
											isPNG
										) {
											notification.error({
												message: 'File Type Error',
												description: `GIF, video, image and audio files are not allowed.`,
											});
										}

										return (
											isLt10M &&
											!isGIF &&
											!isVideo &&
											!isAudio &&
											!isJPEG &&
											!isJPG &&
											!isPNG
										);
									}}
									// accept=".pdf,.jpeg,.jpg,.png"
									accept=".pdf"
									onChange={handleClinicalDocsChange}
								>
									<p className="ant-upload-drag-icon">
										<InboxOutlined
											style={{ color: '#007299' }}
										/>
									</p>
									<p className="ant-upload-text">
										Click or drag file to this area to
										upload
									</p>
								</Dragger>
							</XTheme2Form.Item>
						</XTheme2Form>
					</Modal>

					{/* Clinical audio Upload */}
					<XThemeModal
						// title="Upload Clinical Audio"
						title={
							<>
								<span className="modalTitleIcon">
									<img
										src="/images/upload-modal-icon.svg"
										alt="Add"
									/>
								</span>
								Upload Clinical Audio
							</>
						}
						open={isClinicalUploadAudioModalOpen}
						onOk={handleClinicalAudioUpload}
						okButtonProps={{
							loading: clinicalDocsLoading,
							className: 'xThemeButtonSubmit',
						}}
						onCancel={() => {
							if (!clinicalDocsLoading) {
								clinicalAudioForm.resetFields();
								handleUploadAudioCancel();
							}
						}}
						cancelButtonProps={{
							className: 'xThemeCancelSubmit',
						}}
					>
						<XForm
							form={clinicalAudioForm}
							layout="vertical"
							autoComplete="off"
						>
							<XForm.Item
								name="dictate_audio_note"
								rules={[
									{
										required: true,
										validator: (_, value) => {
											if (!audioBlob) {
												return Promise.reject(
													new Error(
														'Please record an audio note before proceeding.',
													),
												);
											}
											return Promise.resolve();
										},
									},
								]}
							>
								<XCardDesktop className="mt-3">
									<div className="timmer mt-3">
										<span>{recordingTime}</span>
									</div>
									<WaveformVisualizer
										isRecording={isRecording}
										isPlaying={isPlaying}
										audioData={audioElementRef?.current}
									/>

									<div className="actionBtns mt-0">
										<Space type="verticle">
											{!audioBlob ? (
												// Recording controls
												isRecording || isPaused ? (
													<>
														<Tooltip
															key="stop-recording"
															title="Stop Recording"
														>
															<XActionBtns
																size="large"
																type="primary"
																shape="circle"
																onClick={() => {
																	handleStop();
																}}
																icon={
																	<CloseOutlined />
																}
															/>
														</Tooltip>
														<Tooltip
															key={
																isPaused
																	? 'resume-recording'
																	: 'pause-recording'
															}
															title={
																isPaused
																	? 'Resume Recording'
																	: 'Pause Recording'
															}
														>
															<XActionPlay
																type="primary"
																shape="circle"
																onClick={
																	isPaused
																		? handleResume
																		: handlePause
																}
																icon={
																	isPaused ? (
																		<PlayCircleOutlined />
																	) : (
																		<PauseOutlined />
																	)
																}
															/>
														</Tooltip>
														<Tooltip
															key="finish-recording"
															title="Finish Recording"
														>
															<XActionBtns
																size="large"
																type="primary"
																shape="circle"
																onClick={
																	handleDone
																}
																icon={
																	<CheckOutlined />
																}
															/>
														</Tooltip>
													</>
												) : (
													<Tooltip
														key="start-dictation"
														title="Start Dictation"
													>
														<AipaAudioBtn
															size="large"
															onClick={
																toggleDictation
															}
															icon={
																<AudioOutlined />
															}
														/>
													</Tooltip>
												)
											) : (
												// Playback controls
												<>
													<Tooltip
														key="restart"
														title="Restart"
													>
														<XActionBtns
															size="large"
															type="primary"
															shape="circle"
															onClick={() => {
																handleStop(
																	'reset',
																);
																// setAudioBlob(
																// 	null,
																// );
																// audioElementRef.current =
																// 	null;
															}}
															icon={
																<RedoOutlined />
															}
														/>
													</Tooltip>
													<Tooltip
														key={
															isPlaying
																? 'pause-playback'
																: 'play-recording'
														}
														title={
															isPlaying
																? 'Pause Recording'
																: 'Play Recording'
														}
													>
														<XActionPlay
															type="primary"
															shape="circle"
															onClick={
																isPlaying
																	? handlePausePlayback
																	: handlePlayRecording
															}
															icon={
																isPlaying ? (
																	<PauseOutlined />
																) : (
																	<PlayCircleOutlined />
																)
															}
														/>
													</Tooltip>
													<XActionBtns
														size="large"
														type="primary"
														shape="circle"
														style={{
															visibility:
																'hidden',
														}} // Makes the button invisible
														// icon={
														// 	<PauseOutlined />
														// } // Any icon, it won't be visible
													/>
												</>
											)}
										</Space>
									</div>
								</XCardDesktop>
							</XForm.Item>
						</XForm>
					</XThemeModal>

					{/* Clinical Audio Play */}
					<XThemeModal
						title="Listen to Clinical Audio"
						open={audioPlayModal}
						footer={null}
						onCancel={() => {
							handlePlayAudioCancel();
						}}
						// cancelButtonProps={{
						// 	style: { color: '#007299', borderRadius: '20px' },
						// }}
					>
						<XCardDesktop>
							<div className="timmer mt-3">
								<span>{recordingTime}</span>
							</div>
							<WaveformVisualizer
								isRecording={isRecording}
								isPlaying={isPlaying}
								audioData={audioElementRef?.current}
							/>

							<div className="actionBtns mt-0">
								<Space type="verticle">
									{/* Playback controls */}
									{fileToPlay && (
										<>
											<Tooltip
												key="restart"
												title="Restart"
											>
												<XActionBtns
													size="large"
													type="primary"
													shape="circle"
													style={{
														visibility: 'hidden',
													}}
													onClick={() => {
														// handleStop('reset');
														// setAudioBlob(
														// 	null,
														// );
														// audioElementRef.current =
														// 	null;
													}}
													icon={<RedoOutlined />}
												/>
											</Tooltip>
											<Tooltip
												key={
													isPlaying
														? 'pause-playback'
														: 'play-recording'
												}
												title={
													isPlaying
														? 'Pause Recording'
														: 'Play Recording'
												}
											>
												<XActionPlay
													type="primary"
													shape="circle"
													onClick={
														isPlaying
															? handlePausePlayback
															: handlePlayRecordedNote
													}
													icon={
														isPlaying ? (
															<PauseOutlined />
														) : (
															<PlayCircleOutlined />
														)
													}
												/>
											</Tooltip>
											<XActionBtns
												size="large"
												type="primary"
												shape="circle"
												style={{
													visibility: 'hidden',
												}} // Makes the button invisible
												// icon={
												// 	<PauseOutlined />
												// } // Any icon, it won't be visible
											/>
										</>
									)}
								</Space>
							</div>
						</XCardDesktop>
					</XThemeModal>
				</Col>

				{/* Extracted Supporting documents */}
				{!aipa &&
				!mainDataLoading &&
				(patientData?.summary_docs || supportingDocsSummary) ? (
					<Col xs={24} sm={24} lg={12}>
						<XThemeCardCaseOperations
							className="haveHeader bgColorClinical"
							// className={
							// 	expandedStates
							// 		? 'haveHeader bgColorClinical'
							// 		: 'haveHeader bgColorClinical fullScreen noCardPadding'
							// }
							title={
								<Row
									gutter={[15, 15]}
									className="align-items-center"
								>
									<Col xs={20} lg={16}>
										<Space align="center">
											<img
												className="iconResp"
												src="/images/document-summary-icon.svg"
												alt=""
											/>
											<XTitleHead>
												<div className="titleHeading">
													Document Summary
												</div>
											</XTitleHead>
										</Space>
									</Col>
									<Col xs={4} lg={8} className="text-end">
										<Tooltip
											title="Expand"
											color={
												Theme.CQColors.secondaryColor
											}
										>
											{documentsToDisplay?.length > 0 &&
											documentsToDisplay.some(
												(doc) => doc.info,
											) ? (
												<XButtonConfirm
													layoutId="morphingModalSummaryMultiple"
													className="motionOpenBtn"
													onClick={
														handleSummaryMultipleFullscreenOpen
													}
													ref={
														triggerSummaryMultipleRef
													}
													icon={<ArrowsAltOutlined />}
													size="middle"
													shape="circle"
													iconPosition="end"
												/>
											) : (
												<XButtonConfirm
													layoutId="morphingModalSummary"
													className="motionOpenBtn"
													onClick={
														handleSummaryFullscreenOpen
													}
													ref={triggerSummaryRef}
													icon={<ArrowsAltOutlined />}
													size="middle"
													shape="circle"
													iconPosition="end"
												/>
											)}
										</Tooltip>
									</Col>
								</Row>
							}
						>
							{!aipa && documentsToDisplay.length > 0 && (
								<XThemeCardSupportingDocument className="mb-3">
									{/* <Row className="mb-3">
										<Col xs={24}>
											<h2>Supporting Document</h2>
										</Col>
									</Row> */}
									<Row
										gutter={(15, 15)}
										className="align-items-center"
									>
										{documentsToDisplay.length > 0 &&
											documentsToDisplay.map(
												(doc, index) => {
													const isPDF =
														doc.url.name
															.split('.')
															.pop() === 'pdf';
													return (
														<span
															key={index}
															className="me-2"
														>
															<Tooltip
																title={
																	doc.document_name
																}
																placement="top"
																color={
																	Theme
																		.CQColors
																		.secondaryColor
																}
															>
																<Space
																	onClick={() =>
																		handlePreview(
																			doc.url,
																		)
																	}
																>
																	<XSupportingDocument>
																		<div className="left">
																			<img
																				src="/images/pdf.svg"
																				alt={
																					doc.document_name
																				}
																			/>
																		</div>
																		<div className="right">
																			{
																				doc.document_name
																			}
																		</div>
																		{/* <div className="deleteIcon">
																			<img
																				src="/images/delete-icon-new.svg"
																				alt="Delete"
																			/>
																		</div> */}
																	</XSupportingDocument>
																</Space>
															</Tooltip>
														</span>
													);
												},
											)}
									</Row>
								</XThemeCardSupportingDocument>
							)}
							{!mainDataLoading &&
							(patientData?.summary_docs ||
								supportingDocsSummary) ? (
								<>
									{/* Display individual document summaries if available */}
									{documentsToDisplay?.length > 0 &&
										documentsToDisplay.some(
											(doc) => doc.info,
										) &&
										documentsToDisplay.map(
											(doc, index) =>
												doc.info && (
													<XThemeCardSummaryEdit
														className="mb-3"
														key={index}
													>
														<div className="para text-justify">
															<>
																<div
																	style={{
																		fontWeight:
																			'bold',
																		marginBottom:
																			'8px',
																	}}
																>
																	{doc.document_name
																		? `Document Name: ${doc.document_name}`
																		: ''}
																</div>
																<div
																	className="content-wrapper"
																	style={{
																		maxHeight:
																			expandedStates[
																				index
																			]
																				? 'none'
																				: '200px',
																		overflow:
																			'hidden',
																		position:
																			'relative',
																	}}
																>
																	<div
																		ref={(
																			el,
																		) =>
																			(contentRefs.current[
																				index
																			] =
																				el)
																		}
																		dangerouslySetInnerHTML={{
																			__html: doc.info,
																		}}
																	/>
																	{!expandedStates[
																		index
																	] &&
																		contentRefs
																			.current[
																			index
																		]
																			?.scrollHeight >
																			200 && (
																			<div
																				style={{
																					position:
																						'absolute',
																					bottom: 0,
																					left: 0,
																					right: 0,
																					height: '50px',
																					background:
																						'linear-gradient(transparent, white)',
																				}}
																			/>
																		)}
																</div>
																{contentRefs
																	.current[
																	index
																]
																	?.scrollHeight >
																	200 && (
																	<div
																		onClick={() => {
																			handleSummaryMultipleFullscreenOpen();
																		}}
																		ref={
																			triggerSummaryMultipleRef
																		}
																		layoutId="morphingModalSummaryMultiple"
																		className="readMore"
																	>
																		Read
																		More
																	</div>
																)}
															</>
														</div>
													</XThemeCardSummaryEdit>
												),
										)}
									<XThemeMotionMode>
										<AnimatePresence mode="wait">
											{summaryMultipleFullscreenOpen && (
												<>
													<div
														className="motionAnimateWrapper"
														style={{
															marginLeft:
																window.innerWidth <=
																991
																	? 0
																	: props.collapsed
																	? 80
																	: 210,
															width:
																window.innerWidth <=
																991
																	? '100%'
																	: props.collapsed
																	? 'calc(100% - 80px)'
																	: 'calc(100% - 210px)',
														}}
													>
														{/* Backdrop - covers the entire main content area */}
														<motion.div
															className="motionBackdrop"
															onClick={
																handleSummaryMultipleFullscreenClose
															}
														/>
														{/* Modal Content - morphs from the trigger div */}
														<motion.div
															layoutId="morphingModalSummaryMultiple"
															initial={{
																opacity: 0,
																scale: 0,
															}}
															animate={{
																opacity: 1,
																scale: 1,
															}}
															exit={{
																opacity: 0,
																scale: 0,
															}}
															className="motionContent"
														>
															{/* Close button */}
															<XTheme2Button
																icon={
																	<CloseOutlined />
																}
																onClick={
																	handleSummaryMultipleFullscreenClose
																}
																size="large"
																shape="circle"
																className="motionCloseBtn"
															/>
															{documentsToDisplay?.length >
																0 &&
																documentsToDisplay.map(
																	(
																		doc,
																		index,
																	) =>
																		doc.info && (
																			<XThemeCardSummaryEdit
																				// className={`mb-3 ${
																				// 	expandedStates
																				// 		? 'bodyEditCardScroll'
																				// 		: ''
																				// }`}
																				className="mb-3"
																			>
																				<div
																					className="para text-justify"
																					key={
																						index
																					}
																				>
																					<>
																						<div
																							style={{
																								fontWeight:
																									'bold',
																								marginBottom:
																									'8px',
																							}}
																						>
																							{doc.document_name
																								? `Document Name: ${doc.document_name}`
																								: ''}
																						</div>
																						<div
																							className="content-wrapper"
																							// className={`content-wrapper ${
																							// 	expandedStates[
																							// 		index
																							// 	]
																							// 		? 'expanded'
																							// 		: ''
																							// }`}
																							style={{
																								maxHeight:
																									expandedStates[
																										index
																									]
																										? 'none'
																										: '200px',
																								overflow:
																									'hidden',
																								position:
																									'relative',
																							}}
																						>
																							<div
																								ref={(
																									el,
																								) =>
																									(contentRefs.current[
																										index
																									] =
																										el)
																								}
																								dangerouslySetInnerHTML={{
																									__html: doc.info,
																								}}
																							/>
																							{!expandedStates[
																								index
																							] &&
																								contentRefs
																									.current[
																									index
																								]
																									?.scrollHeight >
																									200 && (
																									<div
																										style={{
																											position:
																												'absolute',
																											bottom: 0,
																											left: 0,
																											right: 0,
																											height: '50px',
																											background:
																												'linear-gradient(transparent, white)',
																										}}
																									/>
																								)}
																						</div>
																						{contentRefs
																							.current[
																							index
																						]
																							?.scrollHeight >
																							200 && (
																							<div
																								onClick={() => {
																									const newExpandedStates =
																										[
																											...expandedStates,
																										];
																									newExpandedStates[
																										index
																									] =
																										!newExpandedStates[
																											index
																										];
																									setExpandedStates(
																										newExpandedStates,
																									);
																								}}
																								className="readMore"
																							>
																								{expandedStates[
																									index
																								]
																									? 'Read Less'
																									: 'Read More'}
																							</div>
																						)}
																					</>
																				</div>
																			</XThemeCardSummaryEdit>
																		),
																)}
														</motion.div>
													</div>
												</>
											)}
										</AnimatePresence>
									</XThemeMotionMode>

									{/* Display patientData.summary_docs if it exists */}
									{(!documentsToDisplay?.length ||
										!documentsToDisplay.some(
											(doc) => doc.info,
										)) && (
										<XThemeCardSummaryEdit
											//className="bodyEditCardScroll mb-3"
											// className={`mb-3 ${
											// 	expandedStates
											// 		? 'bodyEditCardScroll'
											// 		: ''
											// }`}
											className="mb-3"
										>
											<div className="para text-justify">
												<div
													// className={`content-wrapper ${
													// 	mainExpanded
													// 		? 'expanded'
													// 		: ''
													// }`}
													className="content-wrapper"
													style={{
														maxHeight: mainExpanded
															? 'none'
															: '200px',
														overflow: 'hidden',
														position: 'relative',
													}}
												>
													<div
														ref={mainContentRef}
														dangerouslySetInnerHTML={{
															__html: isOpenAnalysis
																? supportingDocsSummary
																: currentRevision?.field ===
																  'summary_docs'
																? currentRevision?.finalValue
																: patientData.summary_docs,
														}}
													/>
													<XThemeMotionMode>
														<AnimatePresence mode="wait">
															{summaryFullscreenOpen && (
																<div
																	className="motionAnimateWrapper"
																	style={{
																		marginLeft:
																			window.innerWidth <=
																			991
																				? 0
																				: props.collapsed
																				? 80
																				: 210,
																		width:
																			window.innerWidth <=
																			991
																				? '100%'
																				: props.collapsed
																				? 'calc(100% - 80px)'
																				: 'calc(100% - 210px)',
																	}}
																>
																	{/* Backdrop - covers the entire main content area */}
																	<motion.div
																		className="motionBackdrop"
																		onClick={
																			handleSummaryFullscreenClose
																		}
																	/>
																	{/* Modal Content - morphs from the trigger div */}
																	<motion.div
																		layoutId="morphingModalSummary"
																		initial={{
																			opacity: 0,
																			scale: 0,
																		}}
																		animate={{
																			opacity: 1,
																			scale: 1,
																		}}
																		exit={{
																			opacity: 0,
																			scale: 0,
																		}}
																		className="motionContent"
																	>
																		{/* Close button */}
																		<XTheme2Button
																			icon={
																				<CloseOutlined />
																			}
																			onClick={
																				handleSummaryFullscreenClose
																			}
																			size="large"
																			shape="circle"
																			className="motionCloseBtn"
																		/>
																		<div
																			ref={
																				mainContentRef
																			}
																			dangerouslySetInnerHTML={{
																				__html: isOpenAnalysis
																					? supportingDocsSummary
																					: currentRevision?.field ===
																					  'summary_docs'
																					? currentRevision?.finalValue
																					: patientData.summary_docs,
																			}}
																		/>
																	</motion.div>
																</div>
															)}
														</AnimatePresence>
													</XThemeMotionMode>
													{!mainExpanded &&
														mainContentRef.current
															?.scrollHeight >
															200 && (
															<div
																style={{
																	position:
																		'absolute',
																	bottom: 0,
																	left: 0,
																	right: 0,
																	height: '50px',
																	background:
																		'linear-gradient(transparent, white)',
																}}
															/>
														)}
												</div>
												{/* {mainContentRef.current
													?.scrollHeight > 200 && ( */}
												<div
													// onClick={() =>
													// 	setMainExpanded(
													// 		!mainExpanded,
													// 	)
													// }
													onClick={
														handleSummaryFullscreenOpen
													}
													ref={triggerSummaryRef}
													layoutId="morphingModalSummary"
													className="readMore"
												>
													{/* {mainExpanded
														? 'Read Less'
														: 'Read More'} */}
													Read More
												</div>
												{/* )} */}
											</div>
										</XThemeCardSummaryEdit>
									)}
									{/* <ReadMoreArea
									expandLabel="Read More"
									collapseLabel="Read Less"
									className="readMore"
								>
									{isOpenAnalysis
										? supportingDocsSummary
										: currentRevision?.field ===
										  'summary_docs'
										? currentRevision?.finalValue
										: patientData.summary_docs}
								</ReadMoreArea> */}
								</>
							) : (
								''
							)}
						</XThemeCardCaseOperations>
					</Col>
				) : (
					''
				)}

				{!aipa && (
					<>
						{/* Past Clicnical History */}
						<Col xs={24} sm={24} lg={12}>
							<XThemeCardCaseOperations
								className="haveHeader bgColorClinical"
								title={
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={20} lg={20}>
											<Space align="center">
												<img
													className="iconResp"
													src="/images/previous-clinical-history-icon.svg"
													alt=""
												/>
												<XTitleHead>
													<span className="color1">
														Previous Clinical
														History
													</span>
												</XTitleHead>
											</Space>
										</Col>
										{!previewMode && (
											<Col
												xs={4}
												lg={4}
												className="text-end"
											>
												{currentRevision?.field ===
												'past_history' ? (
													<></>
												) : (
													<Tooltip
														title="Add"
														color={
															Theme.CQColors
																.secondaryColor
														}
													>
														<XButtonAdd
															icon={
																<PlusOutlined />
															}
															onClick={() => {
																form.setFieldsValue(
																	{
																		modal_text_area:
																			'',
																	},
																);
																setModalTextArea(
																	'',
																);
																setModalOpen([
																	true,
																	'Add Past Clinical History',
																	'',
																	null,
																	'pastHistory',
																]);
															}}
															size="middle"
															shape="square"
															iconPosition="end"
														/>
													</Tooltip>
												)}
											</Col>
										)}
									</Row>
								}
							>
								{currentRevision?.field === 'past_history' &&
								currentRevision?.finalValue &&
								currentRevision?.finalValue.length > 0
									? currentRevision?.finalValue.map(
											(row, index) => {
												const splitPastHistory =
													row.value.split(
														'- ICD-10 Code:',
													);

												return (
													<>
														<XRecommendedMobCard
															bgColor="#ffffff"
															className="mt-2 showMobile"
															style={{
																backgroundColor:
																	row.type ===
																	'added'
																		? '#e1fcef'
																		: row.type ===
																		  'removed'
																		? '#FFE9DA'
																		: '',
															}}
														>
															<>
																<Row>
																	<Col
																		xs={22}
																	>
																		{splitPastHistory.length >
																		1 ? (
																			<div className="drowdownTitle mb-2">
																				{
																					splitPastHistory[0]
																				}
																			</div>
																		) : (
																			<div className="drowdownTitle mb-2">
																				{
																					row.value
																				}
																			</div>
																		)}
																	</Col>
																	{!previewMode && (
																		<Col
																			xs={
																				2
																			}
																			className="text-end"
																		>
																			{/* <XMobDropdown.Button
																	type="text"
																	disabled
																	menu={{
																		items: [
																			{
																				label: 'Edit',
																				key: '1',
																				icon: (
																					<EditOutlined />
																				),
																				onClick:
																					() => {
																						form.setFieldsValue(
																							{
																								modal_text_area:
																									row,
																							},
																						);
																						setModalTextArea(
																							row,
																						);
																						setModalOpen(
																							[
																								true,
																								`Edit Past Clinical History`,
																								row,
																								index,
																								'pastHistory',
																							],
																						);
																					},
																			},
																			{
																				type: 'divider',
																			},
																			{
																				label: 'Delete',
																				key: '2',
																				icon: (
																					<DeleteOutlined />
																				),
																				onClick:
																					() => {
																						showDeleteConfirm(
																							'Past Clinical History',
																							index,
																							row,
																							'pastHistory',
																						);
																					},
																			},
																		],
																	}}
																	trigger={[
																		'click',
																	]}
																/> */}
																		</Col>
																	)}
																	{splitPastHistory.length >
																		1 && (
																		<Col
																			xs={
																				24
																			}
																			onClick={() => {
																				handleCodeClick(
																					'ICD-10',
																					{
																						code: splitPastHistory[1],
																						description:
																							splitPastHistory[0],
																						codeTypeText:
																							'pastHistory',
																						buttontext:
																							'Add in Past',
																					},
																				);
																			}}
																			role="button"
																		>
																			<div className="drowdownSubTitle">
																				ICD-10:
																				{
																					splitPastHistory[1]
																				}
																			</div>
																		</Col>
																	)}
																</Row>
															</>
														</XRecommendedMobCard>

														<XDesktopActionCard
															bgColor="#ffffff"
															className="showDesktop"
															style={{
																backgroundColor:
																	row.type ===
																	'added'
																		? '#e1fcef'
																		: row.type ===
																		  'removed'
																		? 'rgb(255, 236, 236)'
																		: '#ffffff',
															}}
														>
															<Row className="align-items-center justify-content-between">
																<Col
																	xs={24}
																	lg={14}
																>
																	{splitPastHistory.length >
																	1 ? (
																		<XPara1>
																			{
																				splitPastHistory[0]
																			}
																		</XPara1>
																	) : (
																		<XPara1>
																			{
																				row.value
																			}
																		</XPara1>
																	)}
																</Col>
																{splitPastHistory.length >
																	1 && (
																	<Col
																		xs={24}
																		lg={8}
																		className="text-center"
																		onClick={() => {
																			handleCodeClick(
																				'ICD-10',
																				{
																					code: splitPastHistory[1],
																					description:
																						splitPastHistory[0],
																					codeTypeText:
																						'pastHistory',
																					buttontext:
																						'Add in Past',
																				},
																			);
																		}}
																		role="button"
																	>
																		<XPara1>
																			<span className="hoverGradient">
																				ICD-10:
																				{
																					splitPastHistory[1]
																				}
																			</span>
																		</XPara1>
																	</Col>
																)}
																{!previewMode && (
																	<Col
																		xs={24}
																		lg={2}
																		className="text-center"
																	>
																		{/* <XButtonImg
																style={{
																	background:
																		'white',
																	boxShadow:
																		'0px 0px 10px 0px #0000001A',
																}}
																disabled
																icon={
																	<img
																		src="/images/edit-icon.svg"
																		alt="Edit"
																	/>
																}
																className="me-3"
																type="text"
																onClick={() => {
																	form.setFieldsValue(
																		{
																			modal_text_area:
																				row,
																		},
																	);
																	setModalTextArea(
																		row,
																	);
																	setModalOpen(
																		[
																			true,
																			`Edit Past Clinical History`,
																			row,
																			index,
																			'pastHistory',
																		],
																	);
																}}
															></XButtonImg>
															<XButtonImg
																style={{
																	background:
																		'white',
																	boxShadow:
																		'0px 0px 10px 0px #0000001A',
																}}
																disabled
																icon={
																	<img
																		src="/images/delete-icon-new.svg"
																		alt="Delete"
																	/>
																}
																type="text"
																onClick={() => {
																	showDeleteConfirm(
																		'Past Clinical History',
																		index,
																		row,
																		'pastHistory',
																	);
																}}
															></XButtonImg> */}
																	</Col>
																)}
															</Row>
														</XDesktopActionCard>
													</>
												);
											},
									  )
									: null}
								{currentRevision?.field !== 'past_history' &&
								pageContent.pastHistory.length > 0
									? pageContent.pastHistory.map(
											(row, index) => {
												const splitPastHistory =
													row.split('- ICD-10 Code:');

												return (
													<>
														<XRecommendedMobCard
															bgColor="#ffffff"
															className="mt-2 showMobile"
														>
															<>
																<Row>
																	<Col
																		xs={22}
																	>
																		{splitPastHistory.length >
																		1 ? (
																			<div className="drowdownTitle mb-2">
																				{
																					splitPastHistory[0]
																				}
																			</div>
																		) : (
																			<div className="drowdownTitle mb-2">
																				{
																					row
																				}
																			</div>
																		)}
																	</Col>
																	{!previewMode && (
																		<Col
																			xs={
																				2
																			}
																			className="text-end"
																		>
																			<XMobDropdown.Button
																				type="text"
																				menu={{
																					items: [
																						{
																							label: 'Edit',
																							key: '1',
																							icon: (
																								<EditOutlined />
																							),
																							onClick:
																								() => {
																									form.setFieldsValue(
																										{
																											modal_text_area:
																												row,
																										},
																									);
																									setModalTextArea(
																										row,
																									);
																									setModalOpen(
																										[
																											true,
																											`Edit Past Clinical History`,
																											row,
																											index,
																											'pastHistory',
																										],
																									);
																								},
																						},
																						{
																							type: 'divider',
																						},
																						{
																							label: 'Delete',
																							key: '2',
																							icon: (
																								<DeleteOutlined />
																							),
																							onClick:
																								() => {
																									showDeleteConfirm(
																										'Past Clinical History',
																										index,
																										row,
																										'pastHistory',
																									);
																								},
																						},
																					],
																				}}
																				trigger={[
																					'click',
																				]}
																			/>
																		</Col>
																	)}
																	{splitPastHistory.length >
																		1 && (
																		<Col
																			xs={
																				24
																			}
																			onClick={() => {
																				handleCodeClick(
																					'ICD-10',
																					{
																						code: splitPastHistory[1],
																						description:
																							splitPastHistory[0],
																						codeTypeText:
																							'pastHistory',
																						buttontext:
																							'Add in Past',
																					},
																				);
																			}}
																			role="button"
																		>
																			<div className="drowdownSubTitle">
																				ICD-10:
																				{
																					splitPastHistory[1]
																				}
																			</div>
																		</Col>
																	)}
																</Row>
															</>
														</XRecommendedMobCard>
														<XDesktopActionCard
															bgColor="#ffffff"
															className="showDesktop"
														>
															<Row className="align-items-center justify-content-between">
																<Col
																	xs={24}
																	lg={14}
																>
																	{splitPastHistory.length >
																	1 ? (
																		<XPara1>
																			{
																				splitPastHistory[0]
																			}
																		</XPara1>
																	) : (
																		<XPara1>
																			{
																				row
																			}
																		</XPara1>
																	)}
																</Col>
																{splitPastHistory.length >
																	1 && (
																	<Col
																		xs={24}
																		lg={8}
																		className="text-center"
																		onClick={() => {
																			handleCodeClick(
																				'ICD-10',
																				{
																					code: splitPastHistory[1],
																					description:
																						splitPastHistory[0],
																					codeTypeText:
																						'pastHistory',
																					buttontext:
																						'Add in Past',
																				},
																			);
																		}}
																		role="button"
																	>
																		<XPara1>
																			<span className="hoverGradient">
																				ICD-10:
																				{
																					splitPastHistory[1]
																				}
																			</span>
																		</XPara1>
																	</Col>
																)}
																{!previewMode && (
																	<Col
																		xs={24}
																		lg={2}
																		className="text-center"
																	>
																		{/* <XButtonImg
																			style={{
																				background:
																					'white',
																				boxShadow:
																					'0px 0px 10px rgba(0, 0, 0, 0.15)',
																			}}
																			icon={
																				<img
																					src="/images/edit-icon.svg"
																					alt="Edit"
																				/>
																			}
																			className="me-3"
																			type="text"
																			onClick={() => {
																				form.setFieldsValue(
																					{
																						modal_text_area:
																							row,
																					},
																				);
																				setModalTextArea(
																					row,
																				);
																				setModalOpen(
																					[
																						true,
																						`Edit Past Clinical History`,
																						row,
																						index,
																						'pastHistory',
																					],
																				);
																			}}
																		></XButtonImg>
																		<XButtonImg
																			style={{
																				background:
																					'white',
																			}}
																			icon={
																				<img
																					src="/images/delete-icon-new.svg"
																					alt="Delete"
																				/>
																			}
																			type="text"
																			onClick={() => {
																				showDeleteConfirm(
																					'Past Clinical History',
																					index,
																					row,
																					'pastHistory',
																				);
																			}}
																		></XButtonImg> */}
																		<XDesktopCaseFillingDropdown
																			arrow
																			placement="bottomRight"
																			menu={{
																				items: [
																					{
																						label: 'Edit',
																						key: '1',
																						icon: (
																							<EditOutlined />
																						),
																						onClick:
																							() => {
																								form.setFieldsValue(
																									{
																										modal_text_area:
																											row,
																									},
																								);
																								setModalTextArea(
																									row,
																								);
																								setModalOpen(
																									[
																										true,
																										`Edit Past Clinical History`,
																										row,
																										index,
																										'pastHistory',
																									],
																								);
																							},
																					},
																					{
																						type: 'divider',
																					},
																					{
																						label: 'Delete',
																						key: '2',
																						icon: (
																							<DeleteOutlined />
																						),
																						onClick:
																							() => {
																								showDeleteConfirm(
																									'Past Clinical History',
																									index,
																									row,
																									'pastHistory',
																								);
																							},
																					},
																				],
																			}}
																		>
																			<MoreOutlined />
																		</XDesktopCaseFillingDropdown>
																	</Col>
																)}
															</Row>
														</XDesktopActionCard>
													</>
												);
											},
									  )
									: currentRevision?.field !== 'past_history'
									? '-'
									: ''}
							</XThemeCardCaseOperations>
						</Col>

						{/* Present Clicnical History */}
						<Col xs={24} sm={24} lg={12}>
							<XThemeCardCaseOperations
								className="haveHeader bgColorCurrentComplaint"
								title={
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={20} lg={20}>
											<Space align="center">
												<img
													className="iconResp"
													src="/images/current-complaint-icon.svg"
													alt=""
												/>
												<XTitleHead>
													<span className="color2">
														Current Complaint
													</span>
												</XTitleHead>
											</Space>
										</Col>
										{!previewMode && (
											<Col
												xs={4}
												lg={4}
												className="text-end"
											>
												{currentRevision?.field ===
												'present_complaint' ? (
													<></>
												) : (
													<Tooltip
														title="Add"
														color={
															Theme.CQColors
																.secondaryColor
														}
													>
														<XButtonAdd
															icon={
																<PlusOutlined />
															}
															onClick={() => {
																form.setFieldsValue(
																	{
																		modal_text_area:
																			'',
																	},
																);
																setModalTextArea(
																	'',
																);
																setModalOpen([
																	true,
																	'Add Present Complaint',
																	'',
																	null,
																	'presentComplaint',
																]);
															}}
															size="middle"
															shape="square"
															iconPosition="end"
														/>
													</Tooltip>
												)}
											</Col>
										)}
									</Row>
								}
							>
								{currentRevision?.field ===
									'present_complaint' &&
								currentRevision?.finalValue &&
								currentRevision?.finalValue.length > 0
									? currentRevision?.finalValue.map(
											(row, index) => {
												const splitPresentComplaint =
													row.value.split(
														'- ICD-10 Code:',
													);

												return (
													<>
														{/* //mew cards */}
														<XRecommendedMobCard
															bgColor="#ffffff"
															className="mt-2 showMobile"
															style={{
																backgroundColor:
																	row.type ===
																	'added'
																		? '#e1fcef'
																		: row.type ===
																		  'removed'
																		? '#FFE9DA'
																		: '',
															}}
														>
															<>
																<Row>
																	<Col
																		xs={22}
																	>
																		{splitPresentComplaint.length >
																		1 ? (
																			<div className="drowdownTitle mb-2">
																				{
																					splitPresentComplaint[0]
																				}
																			</div>
																		) : (
																			<div className="drowdownTitle mb-2">
																				{
																					row.value
																				}
																			</div>
																		)}
																	</Col>
																	{!previewMode && (
																		<Col
																			xs={
																				2
																			}
																			className="text-end"
																		>
																			{/* <XMobDropdown.Button
																	type="text"
																	disabled
																	menu={{
																		items: [
																			{
																				label: 'Edit',
																				key: '1',
																				icon: (
																					<EditOutlined />
																				),
																				onClick:
																					() => {
																						form.setFieldsValue(
																							{
																								modal_text_area:
																									row,
																							},
																						);
																						setModalTextArea(
																							row,
																						);
																						setModalOpen(
																							[
																								true,
																								`Edit Present Complaint`,
																								row,
																								index,
																								'presentComplaint',
																							],
																						);
																					},
																			},
																			{
																				type: 'divider',
																			},
																			{
																				label: 'Delete',
																				key: '2',
																				icon: (
																					<DeleteOutlined />
																				),
																				onClick:
																					() => {
																						showDeleteConfirm(
																							'Present Complaint',
																							index,
																							row,
																							'presentComplaint',
																						);
																					},
																			},
																		],
																	}}
																	trigger={[
																		'click',
																	]}
																/> */}
																		</Col>
																	)}
																	{splitPresentComplaint.length >
																		1 && (
																		<Col
																			xs={
																				24
																			}
																			style={{
																				borderLeft:
																					'1px solid #57636F26',
																				borderRight:
																					'1px solid #57636F26',
																			}}
																			onClick={() => {
																				handleCodeClick(
																					'ICD-10',
																					{
																						code: splitPresentComplaint[1],
																						description:
																							splitPresentComplaint[0],
																						codeTypeText:
																							'presentComplaint',
																						buttontext:
																							'Add in Present',
																					},
																				);
																			}}
																			role="button"
																		>
																			<div className="drowdownSubTitle">
																				ICD-10:
																				{
																					splitPresentComplaint[1]
																				}
																			</div>
																		</Col>
																	)}
																</Row>
															</>
														</XRecommendedMobCard>

														{/* desktop */}
														<XRecommendedCard
															bgColor="#ffffff"
															className="mt-3 showDesktop"
															style={{
																backgroundColor:
																	row.type ===
																	'added'
																		? '#e1fcef'
																		: row.type ===
																		  'removed'
																		? '#FFE9DA'
																		: '',
															}}
														>
															<Row className="align-items-center justify-content-between">
																<Col
																	xs={24}
																	lg={14}
																>
																	{splitPresentComplaint.length >
																	1 ? (
																		<XPara1>
																			{
																				splitPresentComplaint[0]
																			}
																		</XPara1>
																	) : (
																		<XPara1>
																			{
																				row.value
																			}
																		</XPara1>
																	)}
																</Col>
																{splitPresentComplaint.length >
																	1 && (
																	<Col
																		xs={24}
																		lg={8}
																		className="text-center"
																		onClick={() => {
																			handleCodeClick(
																				'ICD-10',
																				{
																					code: splitPresentComplaint[1],
																					description:
																						splitPresentComplaint[0],
																					codeTypeText:
																						'presentComplaint',
																					buttontext:
																						'Add in Present',
																				},
																			);
																		}}
																		role="button"
																	>
																		<XPara1>
																			<span className="hoverGradient">
																				ICD-10:
																				{
																					splitPresentComplaint[1]
																				}
																			</span>
																		</XPara1>
																	</Col>
																)}
																{!previewMode && (
																	<Col
																		xs={24}
																		lg={2}
																		className="text-center"
																	></Col>
																)}
															</Row>
														</XRecommendedCard>
													</>
												);
											},
									  )
									: null}
								{currentRevision?.field !==
									'present_complaint' &&
								pageContent.presentComplaint.length > 0
									? pageContent.presentComplaint.map(
											(row, index) => {
												const splitPresentComplaint =
													row.split('- ICD-10 Code:');

												return (
													<>
														<XRecommendedMobCard
															bgColor="#ffffff"
															className="mt-2 showMobile"
														>
															<>
																<Row>
																	<Col
																		xs={22}
																	>
																		{splitPresentComplaint.length >
																		1 ? (
																			<div className="drowdownTitle mb-2">
																				{
																					splitPresentComplaint[0]
																				}
																			</div>
																		) : (
																			<div className="drowdownTitle mb-2">
																				{
																					row
																				}
																			</div>
																		)}
																	</Col>
																	{!previewMode && (
																		<Col
																			xs={
																				2
																			}
																			className="text-end"
																		>
																			<XMobDropdown.Button
																				type="text"
																				menu={{
																					items: [
																						{
																							label: 'Edit',
																							key: '1',
																							icon: (
																								<EditOutlined />
																							),
																							onClick:
																								() => {
																									form.setFieldsValue(
																										{
																											modal_text_area:
																												row,
																										},
																									);
																									setModalTextArea(
																										row,
																									);
																									setModalOpen(
																										[
																											true,
																											`Edit Present Complaint`,
																											row,
																											index,
																											'presentComplaint',
																										],
																									);
																								},
																						},
																						{
																							type: 'divider',
																						},
																						{
																							label: 'Delete',
																							key: '2',
																							icon: (
																								<DeleteOutlined />
																							),
																							onClick:
																								() => {
																									showDeleteConfirm(
																										'Present Complaint',
																										index,
																										row,
																										'presentComplaint',
																									);
																								},
																						},
																					],
																				}}
																				trigger={[
																					'click',
																				]}
																			/>
																		</Col>
																	)}
																	{splitPresentComplaint.length >
																		1 && (
																		<Col
																			xs={
																				24
																			}
																			onClick={() => {
																				handleCodeClick(
																					'ICD-10',
																					{
																						code: splitPresentComplaint[1],
																						description:
																							splitPresentComplaint[0],
																						codeTypeText:
																							'presentComplaint',
																						buttontext:
																							'Add in Present',
																					},
																				);
																			}}
																			role="button"
																		>
																			<div className="drowdownSubTitle">
																				ICD-10:
																				{
																					splitPresentComplaint[1]
																				}
																			</div>
																		</Col>
																	)}
																</Row>
															</>
														</XRecommendedMobCard>

														<XDesktopActionCard
															bgColor="#ffffff"
															className="showDesktop"
														>
															<Row className="align-items-center justify-content-between">
																<Col
																	xs={24}
																	lg={14}
																>
																	{splitPresentComplaint.length >
																	1 ? (
																		<XPara1>
																			{
																				splitPresentComplaint[0]
																			}
																		</XPara1>
																	) : (
																		<XPara1>
																			{
																				row
																			}
																		</XPara1>
																	)}
																</Col>
																{splitPresentComplaint.length >
																	1 && (
																	<Col
																		xs={24}
																		lg={8}
																		className="text-center"
																		onClick={() => {
																			handleCodeClick(
																				'ICD-10',
																				{
																					code: splitPresentComplaint[1],
																					description:
																						splitPresentComplaint[0],
																					codeTypeText:
																						'presentComplaint',
																					buttontext:
																						'Add in Present',
																				},
																			);
																		}}
																		role="button"
																	>
																		<XPara1>
																			<span className="hoverGradient">
																				ICD-10:
																				{
																					splitPresentComplaint[1]
																				}
																			</span>
																		</XPara1>
																	</Col>
																)}
																{!previewMode && (
																	<Col
																		xs={24}
																		lg={2}
																		className="text-center"
																	>
																		{/* <XButtonImg
																			style={{
																				background:
																					'white',
																				boxShadow:
																					'0px 0px 10px rgba(0, 0, 0, 0.15)',
																			}}
																			icon={
																				<img
																					src="/images/edit-icon.svg"
																					alt="Edit"
																				/>
																			}
																			className="me-3"
																			type="text"
																			onClick={() => {
																				form.setFieldsValue(
																					{
																						modal_text_area:
																							row,
																					},
																				);
																				setModalTextArea(
																					row,
																				);
																				setModalOpen(
																					[
																						true,
																						`Edit Present Complaint`,
																						row,
																						index,
																						'presentComplaint',
																					],
																				);
																			}}
																		></XButtonImg>
																		<XButtonImg
																			style={{
																				background:
																					'white',
																				boxShadow:
																					'0px 0px 10px rgba(0, 0, 0, 0.15)',
																			}}
																			icon={
																				<img
																					src="/images/delete-icon-new.svg"
																					alt="Delete"
																				/>
																			}
																			type="text"
																			onClick={() => {
																				showDeleteConfirm(
																					'Present Complaint',
																					index,
																					row,
																					'presentComplaint',
																				);
																			}}
																		></XButtonImg> */}
																		<XDesktopCaseFillingDropdown
																			arrow
																			placement="bottomRight"
																			menu={{
																				items: [
																					{
																						label: 'Edit',
																						key: '1',
																						icon: (
																							<EditOutlined />
																						),
																						onClick:
																							() => {
																								form.setFieldsValue(
																									{
																										modal_text_area:
																											row,
																									},
																								);
																								setModalTextArea(
																									row,
																								);
																								setModalOpen(
																									[
																										true,
																										`Edit Present Complaint`,
																										row,
																										index,
																										'presentComplaint',
																									],
																								);
																							},
																					},
																					{
																						type: 'divider',
																					},
																					{
																						label: 'Delete',
																						key: '2',
																						icon: (
																							<DeleteOutlined />
																						),
																						onClick:
																							() => {
																								showDeleteConfirm(
																									'Present Complaint',
																									index,
																									row,
																									'presentComplaint',
																								);
																							},
																					},
																				],
																			}}
																		>
																			<MoreOutlined />
																		</XDesktopCaseFillingDropdown>
																	</Col>
																)}
															</Row>
														</XDesktopActionCard>
													</>
												);
											},
									  )
									: currentRevision?.field !==
									  'present_complaint'
									? '-'
									: ''}
							</XThemeCardCaseOperations>
						</Col>
					</>
				)}

				{!checkCoverage && (
					<>
						{/* Missing Fields and Recommended Procedure */}
						<Col xs={24} sm={24} lg={12}>
							<XThemeCardCaseOperations
								ref={missingFieldsCardRef}
								className="haveHeader bgColorDenialProcedure"
								title={
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={20} lg={20}>
											<Space align="center">
												<img
													className="iconResp"
													src="/images/denial-procedure-icon.svg"
													alt=""
												/>
												<XTitleHead>
													<span className="color3">
														Denial Procedure
													</span>
												</XTitleHead>
											</Space>
										</Col>
										{!missingFieldsModal &&
											!previewMode && (
												<Col
													xs={4}
													lg={4}
													className="text-end"
												>
													{currentRevision?.field ===
													'suggested_treatment' ? (
														<></>
													) : (
														<Tooltip
															title="Add"
															color={
																Theme.CQColors
																	.secondaryColor
															}
														>
															<XButtonAdd
																icon={
																	<PlusOutlined />
																}
																onClick={() => {
																	form.setFieldsValue(
																		{
																			modal_text_area:
																				'',
																		},
																	);
																	setModalTextArea(
																		'',
																	);
																	setModalOpen(
																		[
																			true,
																			'Add Denial Procedure',
																			'',
																			null,
																			'recommendedProcedure',
																		],
																	);
																}}
																size="middle"
																shape="square"
																iconPosition="end"
															/>
														</Tooltip>
													)}
												</Col>
											)}
									</Row>
								}
							>
								{missingFieldsModal ? (
									<>
										<XModalTitle className="ms-2 mt-4">
											Provide us with the below details
											for completing the analysis
										</XModalTitle>
										{missingFieldTitle && (
											<XModalSubtitle className="ms-2 mt-2">
												{missingFieldTitle}
											</XModalSubtitle>
										)}
										<XDivider dashed className="mt-3" />
										<XTheme2Form
											form={missingFieldsForm}
											onFinish={() => {
												missingFieldsForm
													.validateFields()
													.then((values) => {
														setLoading(true);
														reviseCoverageReset();
														reviseCoverage({
															// case_id: patientData._id,
															// analysis_id: id,
															revenue_cycle:
																patientData.revenue_cycle,
															feedbackId:
																feedbackId,
															clinicalHistory:
																pageContent.pastHistory,
															presentComplaint:
																pageContent.presentComplaint,
															recommendedProcedure:
																pageContent.recommendedProcedure,
															medicalCoverage:
																pageContent.medicalCoverage,
															state: isOpenAnalysis
																? state
																: patientData.state,
															provider:
																isOpenAnalysis
																	? provider
																	: patientData
																			.insurance_company
																			?.name,
															missing_fields:
																values,
															last_analysis_data:
																lastAnalysisData,
															supportingDocsSummary:
																isOpenAnalysis
																	? supportingDocsSummary
																	: patientData?.summary_docs,
															...(isOpenAnalysis
																? {
																		analysis_id:
																			id,
																  } // If isOpenAnalysis is true, include analysis_id
																: {
																		case_id:
																			patientData._id,
																  }),
															llm_provider:
																selectedProvider,
															llm_model:
																selectedModel,
															revenue_cycle:
																revenueCycle,
														});
														missingFieldsForm.resetFields();
														setMissingFields([]);
														setMissingFieldInstructions(
															[],
														);
														setMissingFieldsModal(
															false,
														);
													})
													.catch((error) => {
														return;
													});
											}}
											name="groupForm"
											layout="vertical"
											autoComplete="off"
										>
											<Row
												gutter={(15, 0)}
												className="mt-4"
											>
												{missingFieldInstructions.length >
													0 && (
													<Col xs={24}>
														<XList
															size="small"
															header={
																<div>
																	Instructions
																</div>
															}
															bordered
															dataSource={
																missingFieldInstructions
															}
															renderItem={(
																item,
																index,
															) => (
																<List.Item>
																	<XCircle>
																		{index +
																			1}
																	</XCircle>{' '}
																	{item}
																</List.Item>
															)}
														/>
														<br />
													</Col>
												)}

												{missingFields.map(
													(item, index) => {
														if (
															item.type ==
															'textarea'
														) {
															return (
																<Col xs={24}>
																	<XTheme2Form.Item
																		label={
																			<XLabel>
																				{
																					item.label
																				}
																			</XLabel>
																		}
																		name={
																			item.name
																		}
																		rules={[
																			item.hasOwnProperty(
																				'required',
																			) &&
																				item.required && {
																					required: true,
																					message:
																						item.required_error_message ??
																						'Field is required',
																				},
																			item.hasOwnProperty(
																				'regex',
																			) &&
																				item.regex && {
																					validator:
																						(
																							rule,
																							value,
																						) => {
																							let regex =
																								new RegExp(
																									item.regex.slice(
																										1,
																										-1,
																									),
																								);
																							if (
																								!regex.test(
																									value,
																								)
																							)
																								return Promise.reject(
																									new Error(
																										item.regex_error_message ??
																											'Invalid Data',
																									),
																								);
																							return Promise.resolve();
																						},
																				},
																		]}
																	>
																		<TextArea
																			rows={
																				3
																			}
																			name={
																				item.name
																			}
																			showCount
																			className="textArea"
																			placeholder="Enter"
																		></TextArea>
																	</XTheme2Form.Item>
																</Col>
															);
														} else if (
															item.type == 'input'
														) {
															return (
																<Col xs={24}>
																	<XTheme2Form.Item
																		label={
																			<XLabel>
																				{
																					item.label
																				}
																			</XLabel>
																		}
																		name={
																			item.name
																		}
																		rules={[
																			item.hasOwnProperty(
																				'required',
																			) &&
																				item.required && {
																					required: true,
																					message:
																						item.required_error_message ??
																						'Field is required',
																				},
																			item.hasOwnProperty(
																				'regex',
																			) &&
																				item.regex && {
																					validator:
																						(
																							rule,
																							value,
																						) => {
																							let regex =
																								new RegExp(
																									item.regex.slice(
																										1,
																										-1,
																									),
																								);
																							if (
																								!regex.test(
																									value,
																								)
																							)
																								return Promise.reject(
																									new Error(
																										item.regex_error_message ??
																											'Invalid Data',
																									),
																								);
																							return Promise.resolve();
																						},
																				},
																		]}
																	>
																		<Input
																			size="large"
																			name={
																				item.name
																			}
																			placeholder="Enter"
																		></Input>
																	</XTheme2Form.Item>
																</Col>
															);
														} else if (
															item.type ==
															'checkbox'
														) {
															return (
																<>
																	<Col
																		xs={24}
																		key={
																			index
																		}
																	>
																		<XTheme2Form.Item
																			name={
																				item.name
																			}
																			rules={[
																				item.required && {
																					required: true,
																					message:
																						item.required_error_message ??
																						'Field is required',
																				},
																			]}
																		>
																			<XCheckboxGroup
																				name={
																					item.name
																				}
																				style={{
																					display:
																						'flex',
																					flexDirection:
																						'column',
																				}}
																			>
																				<XList
																					className=""
																					size="small"
																					bordered
																					header={
																						<div
																							style={{
																								display:
																									'flex',
																								justifyContent:
																									'space-between',
																								alignItems:
																									'center',
																							}}
																						>
																							<XLabel>
																								{
																									item.label
																								}
																							</XLabel>
																							<XRoundButton
																								shape="circle"
																								icon={
																									<PlusOutlined />
																								}
																								onClick={() =>
																									handleAddOption(
																										index,
																									)
																								}
																							/>
																						</div>
																					}
																					dataSource={
																						item.options
																					}
																					renderItem={(
																						option,
																						idx,
																					) => (
																						<List.Item>
																							<Checkbox
																								value={
																									option.value
																								}
																							>
																								{
																									option.label
																								}
																							</Checkbox>
																						</List.Item>
																					)}
																				/>
																			</XCheckboxGroup>
																		</XTheme2Form.Item>
																	</Col>
																</>
															);
														} else if (
															item.type == 'radio'
														) {
															return (
																<Col
																	xs={24}
																	key={index}
																>
																	<XTheme2Form.Item
																		name={
																			item.name
																		}
																		rules={[
																			item.required && {
																				required: true,
																				message:
																					'Field is required',
																			},
																		]}
																	>
																		<Radio.Group
																			style={{
																				display:
																					'flex',
																				flexDirection:
																					'column',
																			}}
																		>
																			<XList
																				className="normal-header"
																				size="small"
																				bordered
																				header={
																					<div
																						style={{
																							display:
																								'flex',
																							justifyContent:
																								'space-between',
																							alignItems:
																								'center',
																						}}
																					>
																						<XLabel>
																							{
																								item.label
																							}
																						</XLabel>
																					</div>
																				}
																				dataSource={
																					item.options
																				}
																				renderItem={(
																					option,
																					idx,
																				) => (
																					<List.Item>
																						<Radio
																							value={
																								option.value
																							}
																						>
																							{
																								option.label
																							}
																						</Radio>
																					</List.Item>
																				)}
																			/>
																		</Radio.Group>
																	</XTheme2Form.Item>
																</Col>
															);
														}
													},
												)}
											</Row>
											<Row className="mt-1">
												<Col
													xs={24}
													className="text-end"
												>
													<Space>
														<XTheme2Button
															shape="round"
															type="primary"
															htmlType="submit"
															loading={''}
														>
															Submit
														</XTheme2Button>
													</Space>
												</Col>
											</Row>
										</XTheme2Form>
									</>
								) : currentRevision?.field !==
										'suggested_treatment' &&
								  pageContent.recommendedProcedure.length >
										0 ? (
									pageContent.recommendedProcedure.map(
										(row, index) => {
											const splitRecommendedProcedure =
												row.split('- CPT Code:');

											return (
												<>
													<XRecommendedMobCard
														bgColor="#f5f6ff"
														className="mt-2 showMobile"
													>
														<>
															<Row className="align-items-center">
																<Col xs={22}>
																	{splitRecommendedProcedure.length >
																	1 ? (
																		<div className="drowdownTitle mb-2">
																			{
																				splitRecommendedProcedure[0]
																			}
																		</div>
																	) : (
																		<div className="drowdownTitle mb-2">
																			{
																				row
																			}
																		</div>
																	)}
																</Col>
																{!previewMode && (
																	<Col
																		xs={2}
																		className="text-end"
																	>
																		<XMobDropdown.Button
																			type="text"
																			menu={{
																				items: [
																					{
																						label: 'Edit',
																						key: '1',
																						icon: (
																							<EditOutlined />
																						),
																						onClick:
																							() => {
																								form.setFieldsValue(
																									{
																										modal_text_area:
																											row,
																									},
																								);
																								setModalTextArea(
																									row,
																								);
																								setModalOpen(
																									[
																										true,
																										`Edit Denial Procedure`,
																										row,
																										index,
																										'recommendedProcedure',
																									],
																								);
																							},
																					},
																					{
																						type: 'divider',
																					},
																					{
																						label: 'Delete',
																						key: '2',
																						icon: (
																							<DeleteOutlined />
																						),
																						onClick:
																							() => {
																								showDeleteConfirm(
																									'Denial Procedure',
																									index,
																									row,
																									'recommendedProcedure',
																								);
																							},
																					},
																				],
																			}}
																			trigger={[
																				'click',
																			]}
																		/>
																	</Col>
																)}
																{splitRecommendedProcedure.length >
																	1 && (
																	<Col
																		xs={24}
																		onClick={() => {
																			handleCodeClick(
																				'CPT',
																				{
																					code: splitRecommendedProcedure[1],
																					description:
																						splitRecommendedProcedure[0],
																					codeTypeText:
																						'recommendedProcedure',
																					buttontext:
																						'Add in Denial',
																				},
																			);
																		}}
																		role="button"
																	>
																		<div className="drowdownSubTitle">
																			CPT:
																			{
																				splitRecommendedProcedure[1]
																			}
																		</div>
																	</Col>
																)}
															</Row>
														</>
													</XRecommendedMobCard>

													<XDesktopActionCard
														bgColor="#FFF"
														className="mt-3 showDesktop"
													>
														<Row className="align-items-center justify-content-between">
															<Col
																xs={24}
																lg={14}
															>
																{splitRecommendedProcedure.length >
																1 ? (
																	<XPara1>
																		{
																			splitRecommendedProcedure[0]
																		}
																	</XPara1>
																) : (
																	<XPara1>
																		{row}
																	</XPara1>
																)}
															</Col>
															{splitRecommendedProcedure.length >
																1 && (
																<Col
																	xs={24}
																	lg={8}
																	className="text-center"
																	onClick={() => {
																		handleCodeClick(
																			'CPT',
																			{
																				code: splitRecommendedProcedure[1],
																				description:
																					splitRecommendedProcedure[0],
																				codeTypeText:
																					'recommendedProcedure',
																				buttontext:
																					'Add in Denial',
																			},
																		);
																	}}
																	role="button"
																>
																	<XPara1>
																		<span className="hoverGradient">
																			CPT:
																			{
																				splitRecommendedProcedure[1]
																			}
																		</span>
																	</XPara1>
																</Col>
															)}
															{!previewMode && (
																<Col
																	xs={24}
																	lg={2}
																	className="text-center"
																>
																	{/* <XButtonImg
																		style={{
																			background:
																				'white',
																			boxShadow:
																				'0px 0px 10px rgba(0, 0, 0, 0.15)',
																		}}
																		icon={
																			<img
																				src="/images/edit-icon.svg"
																				alt="Edit"
																			/>
																		}
																		className="me-3"
																		type="text"
																		onClick={() => {
																			form.setFieldsValue(
																				{
																					modal_text_area:
																						row,
																				},
																			);
																			setModalTextArea(
																				row,
																			);
																			setModalOpen(
																				[
																					true,
																					`Edit Denial Procedure`,
																					row,
																					index,
																					'recommendedProcedure',
																				],
																			);
																		}}
																	></XButtonImg>
																	<XButtonImg
																		style={{
																			background:
																				'white',
																			boxShadow:
																				'0px 0px 10px rgba(0, 0, 0, 0.15)',
																		}}
																		icon={
																			<img
																				src="/images/delete-icon-new.svg"
																				alt="Delete"
																			/>
																		}
																		type="text"
																		onClick={() => {
																			showDeleteConfirm(
																				'Denial Procedure',
																				index,
																				row,
																				'recommendedProcedure',
																			);
																		}}
																	></XButtonImg> */}
																	<XDesktopCaseFillingDropdown
																		arrow
																		placement="bottomRight"
																		menu={{
																			items: [
																				{
																					label: 'Edit',
																					key: '1',
																					icon: (
																						<EditOutlined />
																					),
																					onClick:
																						() => {
																							form.setFieldsValue(
																								{
																									modal_text_area:
																										row,
																								},
																							);
																							setModalTextArea(
																								row,
																							);
																							setModalOpen(
																								[
																									true,
																									`Edit Denial Procedure`,
																									row,
																									index,
																									'recommendedProcedure',
																								],
																							);
																						},
																				},
																				{
																					type: 'divider',
																				},
																				{
																					label: 'Delete',
																					key: '2',
																					icon: (
																						<DeleteOutlined />
																					),
																					onClick:
																						() => {
																							showDeleteConfirm(
																								'Denial Procedure',
																								index,
																								row,
																								'recommendedProcedure',
																							);
																						},
																				},
																			],
																		}}
																	>
																		<MoreOutlined />
																	</XDesktopCaseFillingDropdown>
																</Col>
															)}
														</Row>
													</XDesktopActionCard>
												</>
											);
										},
									)
								) : currentRevision?.field ===
										'suggested_treatment' &&
								  currentRevision?.finalValue &&
								  currentRevision?.finalValue.length > 0 ? (
									currentRevision?.finalValue.map(
										(row, index) => {
											const splitRecommendedProcedure =
												row.value.split('- CPT Code:');

											return (
												<>
													{/* new */}
													<XRecommendedMobCard
														bgColor="#f5f6ff"
														className="mt-2 showMobile"
														style={{
															backgroundColor:
																row.type ===
																'added'
																	? '#e1fcef'
																	: row.type ===
																	  'removed'
																	? '#FFE9DA'
																	: '',
														}}
													>
														<>
															<Row className="align-items-center">
																<Col xs={22}>
																	{splitRecommendedProcedure.length >
																	1 ? (
																		<div className="drowdownTitle mb-2">
																			{
																				splitRecommendedProcedure[0]
																			}
																		</div>
																	) : (
																		<div className="drowdownTitle mb-2">
																			{
																				row.value
																			}
																		</div>
																	)}
																</Col>
																{!previewMode && (
																	<Col
																		xs={2}
																		className="text-end"
																	>
																		{/* <XMobDropdown.Button
																type="text"
																disabled
																menu={{
																	items: [
																		{
																			label: 'Edit',
																			key: '1',
																			icon: (
																				<EditOutlined />
																			),
																			onClick:
																				() => {
																					form.setFieldsValue(
																						{
																							modal_text_area:
																								row,
																						},
																					);
																					setModalTextArea(
																						row,
																					);
																					setModalOpen(
																						[
																							true,
																							`Edit Denial Procedure`,
																							row,
																							index,
																							'recommendedProcedure',
																						],
																					);
																				},
																		},
																		{
																			type: 'divider',
																		},
																		{
																			label: 'Delete',
																			key: '2',
																			icon: (
																				<DeleteOutlined />
																			),
																			onClick:
																				() => {
																					showDeleteConfirm(
																						'Denial Procedure',
																						index,
																						row,
																						'recommendedProcedure',
																					);
																				},
																		},
																	],
																}}
																trigger={[
																	'click',
																]}
															/> */}
																	</Col>
																)}
																{splitRecommendedProcedure.length >
																	1 && (
																	<Col
																		xs={24}
																		onClick={() => {
																			handleCodeClick(
																				'CPT',
																				{
																					code: splitRecommendedProcedure[1],
																					description:
																						splitRecommendedProcedure[0],
																					codeTypeText:
																						'recommendedProcedure',
																					buttontext:
																						'Add in Denial',
																				},
																			);
																		}}
																		role="button"
																	>
																		<div className="drowdownSubTitle">
																			CPT:
																			{
																				splitRecommendedProcedure[1]
																			}
																		</div>
																	</Col>
																)}
															</Row>
														</>
													</XRecommendedMobCard>

													<XDesktopActionCard
														bgColor="#FFF"
														className="mt-3 showDesktop"
														style={{
															backgroundColor:
																row.type ===
																'added'
																	? '#e1fcef'
																	: row.type ===
																	  'removed'
																	? '#FFE9DA'
																	: '',
														}}
													>
														<Row className="align-items-center justify-content-between">
															<Col
																xs={24}
																lg={16}
															>
																{splitRecommendedProcedure.length >
																1 ? (
																	<XPara1>
																		{
																			splitRecommendedProcedure[0]
																		}
																	</XPara1>
																) : (
																	<XPara1>
																		{
																			row.value
																		}
																	</XPara1>
																)}
															</Col>
															{splitRecommendedProcedure.length >
																1 && (
																<Col
																	xs={24}
																	lg={6}
																	className="text-center"
																	onClick={() => {
																		handleCodeClick(
																			'CPT',
																			{
																				code: splitRecommendedProcedure[1],
																				description:
																					splitRecommendedProcedure[0],
																				codeTypeText:
																					'recommendedProcedure',
																				buttontext:
																					'Add in Denial',
																			},
																		);
																	}}
																	role="button"
																>
																	<XPara1>
																		<span className="hoverGradient">
																			CPT:
																			{
																				splitRecommendedProcedure[1]
																			}
																		</span>
																	</XPara1>
																</Col>
															)}
															{!previewMode && (
																<Col
																	xs={24}
																	lg={6}
																	className="text-center"
																></Col>
															)}
														</Row>
													</XDesktopActionCard>
												</>
											);
										},
									)
								) : (
									'-'
								)}
							</XThemeCardCaseOperations>
						</Col>
					</>
				)}

				{/* Coding tool */}
				{/* <Col xs={24} sm={12} lg={12}>
					<CardCodingTools
						handleCodeClick={handleCodeClick}
						aipa={aipa}
						previewMode={previewMode}
					/>
				</Col> */}
				{/* Medical Coverage */}
				<Col xs={24}>
					<XThemeCardCaseOperations
						className="haveHeader bgColorMedicareCoverage"
						title={
							<Row
								gutter={[15, 15]}
								className="mb-2 align-items-center"
							>
								<Col xs={24}>
									<Space
										align="center"
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											width: '100%',
										}}
									>
										<Space align="center">
											<img
												className="iconResp"
												src={
													loading
														? '/images/black-cross-icon.svg'
														: missingFieldsModal
														? '/images/black-cross-icon.svg'
														: pageContent
																.medicalCoverage[0] ===
														  'Yes'
														? '/images/coverage-icon.svg'
														: '/images/cross-icon.svg'
												}
												alt=""
											/>
											<XTitleHead>
												<span
													className={`labelHeading ${
														loading
															? 'color6'
															: missingFieldsModal
															? 'color6'
															: pageContent
																	.medicalCoverage[0] ===
															  'Yes'
															? 'color4'
															: 'color5'
													}`}
												>
													Coverage Analysis
												</span>
											</XTitleHead>
										</Space>
										{pageContent.is_retired ? (
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: '10px',
												}}
												className="labelHeading"
											>
												<img
													style={{
														// width: '40px',
														display: 'block',
													}}
													src={
														'/images/retired_hexagon.svg'
													}
													alt="retired"
												/>
												{/* <span style={{ color: '#B72323' }}>Retired</span>  */}
											</div>
										) : (
											''
										)}
									</Space>
								</Col>
							</Row>
						}
					>
						{pageContent.medicalCoverage.length > 0 ? (
							<>
								<Row
									gutter={[15, 15]}
									className="align-items-center mb-2"
								>
									<Col xs={24}>
										<XPara1
											style={{ textAlign: 'justify' }}
										>
											{missingFieldsModal &&
												'Action Awaited on the Above Item'}
											{pageContent.is_retired &&
											pageContent.ncd_reference &&
											pageContent.ncd_reference !== '' ? (
												<span>
													{pageContent.medicalCoverage[1]
														.split(
															new RegExp(
																`(${pageContent.ncd_reference})`,
																'gi',
															),
														)
														.map((part, index) =>
															part.toLowerCase() ===
															pageContent.ncd_reference?.toLowerCase() ? (
																<span
																	key={index}
																	style={{
																		color: '#B72323',
																	}}
																>
																	<strong>
																		{part}*
																	</strong>
																</span>
															) : (
																<span
																	key={index}
																>
																	{part}
																</span>
															),
														)}
												</span>
											) : (
												pageContent.medicalCoverage[1]
											)}
											{pageContent.medicalCoverage[2] &&
											Object.keys(
												pageContent.medicalCoverage[2],
											).length > 0 ? (
												<div className="w-100 mt-2">
													<i>
														Reference:{' '}
														<a
															href={
																pageContent
																	.medicalCoverage[2][
																	'target'
																]
															}
															rel="noreferrer"
															target="_blank"
															className="links2"
														>
															{
																pageContent
																	.medicalCoverage[2][
																	'display_text'
																]
															}
														</a>
													</i>
												</div>
											) : (
												''
											)}
											{pageContent.is_retired &&
											pageContent.retired_message &&
											pageContent.retired_message !==
												'' ? (
												<>
													<XThemeAddressWrap className="mt-3 danger">
														<div className="para text-justify">
															<sub>*</sub>
															{
																pageContent.retired_message
															}
														</div>
													</XThemeAddressWrap>
													{/* <span>
											{pageContent.retired_message}
										</span> */}
												</>
											) : (
												''
											)}
										</XPara1>
									</Col>
								</Row>
							</>
						) : (
							''
						)}
					</XThemeCardCaseOperations>
				</Col>

				{/* Missing Coverage */}
				<Col xs={24}>
					{pageContent.missing_points_for_coverage &&
						pageContent.missing_points_for_coverage.length > 0 && (
							<>
								<XThemeCardCaseOperations
									className="haveHeader bgColorMissingInclusionCriteria"
									title={
										<Row gutter={[15, 15]}>
											<Col xs={24}>
												<Space align="center">
													<img
														src={
															'/images/criteria.svg'
														}
														alt=""
													/>
													<XTitleHead>
														<span class="color7">
															Missing Inclusion
															Criteria
															<Tooltip title="This feature is experimental and may contain errors as it evolves. Please exercise discretion, especially when reviewing critical information.">
																<Tag
																	style={{
																		marginLeft:
																			'15px',
																		border: '1px solid #9B68BF',
																		color: '#9B68BF',
																		fontSize:
																			'11px',
																	}}
																>
																	Alpha
																</Tag>
															</Tooltip>
														</span>
													</XTitleHead>
												</Space>
											</Col>
										</Row>
									}
								>
									<Row
										gutter={(15, 15)}
										className="align-items-center criteria_sub_list"
									>
										<Col xs={24}>
											<ul className="listCircule">
												{pageContent.missing_points_for_coverage?.map(
													(row, index) => {
														return <li>{row}</li>;
													},
												)}
											</ul>
										</Col>
									</Row>
								</XThemeCardCaseOperations>
							</>
						)}
				</Col>
			</Row>

			<XThemeModal
				open={previewOpen}
				title={previewTitle}
				footer={null}
				onCancel={() => setPreviewOpen(false)}
			>
				{previewImage ? (
					<img
						alt="example"
						style={{
							width: '100%',
						}}
						src={previewImage}
					/>
				) : null}
			</XThemeModal>

			{/* Modal for uplodoaded Files preview */}
			<XThemeModal
				open={pdfPreviewOpen}
				title="Preview"
				footer={null}
				onCancel={() => setPdfPreviewOpen(false)}
				width={pdfWidth} // Set the width of the modal dynamically
				// Other modal props...
				zIndex={9999}
			>
				<div>
					<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
						<div style={{ height: '750px' }}>
							<Viewer fileUrl={previewImage} />
						</div>
					</Worker>
				</div>
			</XThemeModal>

			<XThemeModal
				title={
					<>
						<span className="modalTitleIcon">
							{modalOpen[4] !== 'feedbackSummary' &&
							modalOpen[2] === '' ? (
								<img src="/images/add-modal-icon.svg" alt="" />
							) : (
								<img src="/images/edit-modal-icon.svg" alt="" />
							)}
						</span>

						{modalOpen[1]}
					</>
				}
				centered
				open={modalOpen[0]}
				onOk={() => {
					form.validateFields()
						.then((res) => {
							if (modalOpen[4] === 'feedbackSummary') {
								sendFeedback({
									feedback_id: feedbackId,
									feedback: 'negative',
									status: 'pending_for_analysis',
									response: [coverage, modalTextArea],
								});
							} else {
								// Format the text according to the selected code type (ICD-10 or CPT)
								const formattedText = `${
									res.modal_text_area
								} - ${
									modalOpen[4] === 'recommendedProcedure'
										? 'CPT Code'
										: 'ICD-10 Code'
								}: ${res.code}`;
								// Save the formatted text in setModalTextArea
								setModalTextArea(formattedText);

								// Optionally update page content
								updatePageContent(
									modalOpen[4],
									modalOpen[3],
									formattedText,
								);
							}
						})
						.catch((err) => {
							console.log('error', err);
						});
				}}
				okButtonProps={{
					className: 'xThemeButtonSubmit',
					loading: sendFeedbackState.apiState === 'loading',
					// style: {
					// 	backgroundColor: '#007299', // Custom background color
					// 	color: '#fff', // Text color
					// },
				}}
				cancelButtonProps={{
					className: 'xThemeCancelSubmit',
					// Add an icon to the Cancel button
					// style: {
					// 	backgroundColor: '#fff', // Red background for Cancel
					// 	color: '#007299', // Text color
					// },
				}}
				onCancel={() => {
					form.resetFields();
					setModalTextArea('');
					setModalOpen([false, '', ' ']);
				}}
				okText="Submit"
				width={800}
			>
				<XTheme2Form
					form={form}
					name="groupForm"
					layout="vertical"
					autoComplete="off"
				>
					<Row gutter={(15, 15)} className="mt-4">
						<Col xs={24}>
							{modalOpen[4] === 'feedbackSummary' && (
								<>
									<XTheme2Form.Item
										className="drawerlabel"
										name="medicare_flag"
										label="Coverage"
										rules={[
											{
												required: true,
												message: 'Field is required',
											},
										]}
									>
										<XTheme2Select
											className="largeInputForms"
											size="large"
											showSearch
											placeholder="Select a person"
											optionFilterProp="children"
											onChange={(e) => {
												setCoverage(e);
											}}
											options={[
												{
													value: 'Yes',
													label: 'YES',
												},
												{
													value: 'No',
													label: 'NO',
												},
											]}
										/>
									</XTheme2Form.Item>

									<XTheme2Form.Item
										className="textAreaStyleDarkBorder drawerlabel"
										name="modal_text_area"
										rules={[
											{
												required: true,
												message: 'Field is required',
											},
										]}
									>
										<XThemeInputText.TextArea
											size="large"
											rows={6}
											name="modal_text_area"
											showCount
											style={{
												minHeight: 120,
												marginBottom: 24,
											}}
											// className="textArea mt-2"
											placeholder="Enter"
											onChange={(e) =>
												setModalTextArea(e.target.value)
											}
										>
											{/* modalOpen[2] */}
										</XThemeInputText.TextArea>
									</XTheme2Form.Item>
								</>
							)}
							{modalOpen[4] !== 'feedbackSummary' && (
								<>
									<XTheme2Form.Item
										className="textAreaStyleDarkBorder drawerlabel"
										name="modal_text_area"
										label="Description"
										rules={[
											{
												required: true,
												message:
													'Description is required',
											},
										]}
									>
										<XThemeInputText.TextArea
											size="large"
											name="modal_text_area"
											showCount
											// style={{
											// 	height: 100,
											// }}
											rows={6}
											placeholder="Enter description"
										/>
									</XTheme2Form.Item>
									<XTheme2Form.Item
										className="drawerlabel"
										name="code"
										label={`${
											modalOpen[4] ===
											'recommendedProcedure'
												? 'CPT'
												: 'ICD-10'
										} Code`}
										rules={[
											{
												required: true,
												message: 'Code is required',
											},
										]}
									>
										<XThemeInputText
											className="largeInputForms"
											placeholder={`Enter ${
												modalOpen[4] ===
												'recommendedProcedure'
													? 'CPT'
													: 'ICD-10'
											} Code`}
										/>
									</XTheme2Form.Item>
								</>
							)}
						</Col>
					</Row>
				</XTheme2Form>
			</XThemeModal>
			{/* new modal end */}
		</>
	);
};

export default CaseOperations;
